/* eslint-disable react/jsx-no-undef */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable prefer-const */
/* eslint-disable*/

/**PS_NO_AP_01 - PS_NO_AP_03
 * The required hooks and the racstrap elements are imported
 */
import {
  RACButton,
  Grid,
  CircularProgress,
  RACCOLOR,
  makeStyles,
  RACModalCard,
  Typography,
  RACTableRow,
  RACTableCell,
  RACTextbox,
  RACTable,
  RACSelect,
  RACToggle
} from '@rentacenter/racstrap';
import { ReactComponent as AlertIcon } from '../../assets/images/no-records-found.svg';
import { ReactComponent as SuccessIcon } from '../../assets/images/success-icon.svg';
import { useTranslation } from 'react-i18next';
import { BarcodeGeneration } from './BarcodeGeneration';

import { takePaymentStyles } from "../../stylesJS/makeStyles";
import { useHistory } from "react-router";

import { customerStyles } from "../../stylesJS/customerStyles";
import { agreementContext } from "../context/PaymentInformationContext";
import React, { useContext, useState, useRef, useEffect } from "react";
import moment from "moment";
import SecondFactor from "../../racstrapComponents/microfrontends/TwoFactorPopup";
import {
  b64toBlob,
  getContentType,
  getCustDetail,
} from '../../utils/utils';
import {
  GenerateAgreementDoc,
  ProcessPaymentAPI,
  getDocument,
  storeException,
  postAgreementActivity,
  UnEnrollAutoPay,
  UpdateNoDeReason,
  generateInvoice
} from '../../api/user';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { ReactComponent as FailIcon } from '../../assets/images/contest-close.svg';
import { ReactComponent as TransactionSuccessIcon } from '../../../src/assets/images/success-icon-print.svg';
import CustomerSignature from '../../racstrapComponents/microfrontends/CustomerSignature';
import StoreException from './StoreException';
import { LocationParams, ParamType } from '../interface/commonInterface'
import CONSTANTS from '../constants/constant';
import { AgreementDetails, CardDetailsInterface, CoPrelimDetails } from '../interface/paymentInfoInterface';
import { AgreementPaymentEntity, CardDetailsEntity, ClubPaymentEntity, CustomerSignFileds, ExceptionTypeArray, ExchangeAgreementArray, FinalResultArray, FreeTimePopupFlag, GetDocumentResponse, MiscPaymentEntity, PaymentAPIResult, PlaceOrderDetails, ReceiptArrayUrl, ReceiptStatus, ReceiptStatusInfo, ReceiptUrl, StoreExceptionPayload, TakePaymentRequest, TenderDetailsEntity, TransferSuspenseEntity } from '../interface/acceptPaymentInterface';
import { acceptPaymentStyles } from '../../stylesJS/acceptPaymentStyles';
import { CreatePaymentInfoForPayload } from '../utils/acceptPaymentUtills';
import Autopay from './HandleAutopay';
import { AppRoute } from '../../config/route-config';
import { closestIndexTo } from 'date-fns';

export function AcceptPayment() {
  /**PS_NO_AP_08 - PS_NO_AP_10
   * The required state variabel declaration and the destructuring of context variable is done.
   */
  const classes = acceptPaymentStyles();
  const classes2 = takePaymentStyles();
  const classesTwo = customerStyles();
  const history = useHistory();
  const { customerId, agreementId: rawAgreementId } = useParams<ParamType>();
  // Sanitize: strip any query params that may have leaked into the path param (e.g. spendLimitId)
  const agreementId = rawAgreementId?.split('?')[0];
  const {
    agreementDetails,
    storeInfo,
    customerInfo,
    multiStoreSelected,
    paymentDisable,
    cappedFreeTimeDetails,
    coWorkerDetails,
    featureFlags,
    modalCardEnable,
    setModalCardEnable,
    paymentOrigin,
    coPrelimDetails,
    customerOrderPayment,
    facturaDetails,
    taxRegimeOptions,
    useOfCfdiOptions,
    openFacturaModalOne,
    setOpenFacturaModalOne,
    openFacturaModalTwo,
    setOpenFacturaModalTwo,
    selectedReceipt,
    isPaymentHistory,
    setIsPaymentHistory,
    paymentWithdrawCheckbox,
    invoiceGenratedRcpts,
    setInvoiceGenratedRcpts

  } = useContext(agreementContext);
  const [openSuspenseWithdraw, setOpenSuspenseWithdraw] = useState<boolean>(false);
  const [txtChange, settxtChange] = useState<boolean>(false);
  const [sessionExpiredPopupFlag, setSessionExpiredPopupFlag] =
    useState<boolean>(false);
  const [racExchangeAutoPayPopup, setRacExchangeAutoPayPopup] = useState(false);
  const [exceededFreeTime, setExceededFreeTime] = useState<number>(0);
  const [secondFactorOpen, setSecondFactorOpen] = useState<boolean>(false);
  const [popupData, setPopupData] = useState<boolean>(false);
  // const [TwoFactorCompleted, setTwoFactorCompleted] = useState<any>(false);
  const [barcodeAgreements, setBarcodeAgreements] = useState<AgreementDetails[]>([]);
  const [TwoFactorCancelClick, setTwoFactorCancelClick] = useState<boolean>(false);
  const [cofPopup, setcofPopup] = useState<boolean>(false);
  const [freeTimeAuthPopup, setFreeTimeAuthPopup] = useState<FreeTimePopupFlag>({
    popup: false,
    secondFactor: false,
  });
  const { t } = useTranslation('BackRent');

  const [viewReceiptPopup, setviewReceiptPopup] = useState<boolean>(false);
  const [extIndex, setextIndex] = useState<number>(CONSTANTS.ZERO_NUMBER);
  const [isAmountMismatch, setIsAmountMismatch] = useState<boolean>(false);
  const [transactionFail, setTransactionFail] = useState<boolean>(false);
  const [load, setload] = useState<boolean>(false);
  const [receiptID, setReceiptID] = useState<string>(CONSTANTS.EMPTY_STRING);
  const [transactionResultArray, settransactionResultArray] = useState<PaymentAPIResult[]>([]);
  const [finalPaymentResult, setFinalPaymentResult] = useState<FinalResultArray[]>([] as FinalResultArray[]);
  const [initialReceiptStatus, setInitialReceiptStatus] = useState<ReceiptStatus[]>();
  let [receiptResultArray, setreceiptResultArray] = useState<ReceiptStatusInfo>({} as ReceiptStatusInfo);
  const [pifAgreementID, setPifAgreementID] = useState<string>(CONSTANTS.EMPTY_STRING);
  const [redirectToAccountManagement, setRedirectToAccountManagement] = useState<boolean>(false);
  const [showReceiptStatus, setShowReceiptStatus] = useState<boolean>(false);
  const [showPaymentStatus, setShowPaymentStatus] = useState<boolean>(false);
  const [customerSignaturePopup, setcustomerSignaturePopup] = useState<boolean>(false);
  const [customerSignUsingField, setCustomerSignUsingField] = useState<CustomerSignFileds>({
    field: CONSTANTS.EMPTY_STRING,
    moduleName: CONSTANTS.EMPTY_STRING,
    documentType: CONSTANTS.EMPTY_STRING,
  });
  const [cofIndex, setcofIndex] = useState<number>(CONSTANTS.ZERO_NUMBER);
  const [viewCOFPopup, setviewCOFPopup] = useState<boolean>(false);
  const [viewExtPopup, setviewExtPopup] = useState<boolean>(false);
  const [recpt, setrecpt] = useState<boolean>(false);
  const [clubSignFlow, setclubSignFlow] = useState<boolean>(false);
  const [tran, settran] = useState<boolean>(false);
  const [openCommitmentConfirmation, setopenCommitmentConfirmation] = useState<boolean>(false);
  const [cardPaymentFailedMessage, setCardPaymentFailedMessage] = useState<string>('');
  let [exceptionTypeArr, setExceptionTypeArr] = useState<ExceptionTypeArray[]>([]);
  let [storeExceptionRequest, setStoreExceptionRequest] = useState<any>([]);
  let [StoreExceptionEnable, setStoreExceptionEnable] = useState<boolean>(false);
  const [proceedButtonLoader, setProceedButtonLoader] = useState<boolean>(false);
  let [exchangedAgreementArray, setExchangeAgreementArray] = useState<ExchangeAgreementArray[]>([]);
  const [autoPayConfirmationPopup, setAutoPayConfirmationPopup] = useState<boolean>(false);
  const collectStoreNumber: string[] = [];
  const urlParams = new URLSearchParams(window.location.search);
  const retentionType = urlParams.get(CONSTANTS.URLPARAMS_CRTYPE);
  const location = useLocation<LocationParams>();
  const storeNumber = String(window.sessionStorage.getItem(CONSTANTS.STORE_NUMBER));
  let receptFailedAttempts = CONSTANTS.ZERO_NUMBER;
  const [choosenReceiptIndex, setChoosenReceiptIndex] = useState<number>(CONSTANTS.ZERO_NUMBER)
  // : number | undefined = CONSTANTS.ZERO_NUMBER;
  const eventFrame = useRef<HTMLIFrameElement>(null);
  const exchangeAgreementId: string | null = urlParams.get('exchangeAgreementId');
  const [deliveryNonConfirmedAgreements, setDeliveryNonConfirmedAgreements] = useState<any>([]);
  const [isDeliveryPopupOpen, setIsDeliveryPopupOpen] = useState<boolean>(false);
  const [secondPopupData, setSecondPopupData] = useState<boolean>(false);
  const [invoiceError, setInvoiceError] = useState<boolean>(false);
  const [errorPopup, setErrorPoup] = useState<boolean>(false);

  const [formData, setFormData] = useState({
    rfc: '',
    zipCode: '',
    email: '',
    name: `${customerInfo.customerDetails?.[0]?.lastName || ''} ${customerInfo.customerDetails?.[0].firstName || ''}`,
    taxRegime: '',
    useOfCFDI: '',
    generateInvoiceAllPayments: false,
    requiresInvoice: false,
  });
  console.log('form data ', formData);

  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [invoicePopup, setInvoicePopup] = useState<boolean>(false);

  const [showPifPopup, setShowPifPopup] = useState(false);
  const [daysToPif, setDaysToPif] = useState(0);
  const [pifPopupHandled, setPifPopupHandled] = useState(false);
  const [PopupContentType, setPopupContentType] = useState<string>('');

  useEffect(() => {
    if (customerInfo.customerDetails?.length > 0) {
      const customerDetails = customerInfo.customerDetails[0];
      setFormData({
        rfc: '',
        zipCode: '',
        email: '',
        name: `${customerDetails.lastName || ''} ${customerDetails.firstName || ''}`,
        taxRegime: '1',
        useOfCFDI: '1',
        generateInvoiceAllPayments: false,
        requiresInvoice: false,
      });
    }
  }, [customerInfo]);

  useEffect(() => {
    const { rfc, zipCode, email, name, taxRegime, useOfCFDI } = formData;

    const allFieldsFilled = [rfc, zipCode, email, name].every(val => val !== '' && val !== null);
    const isTaxRegimeValid = Number(taxRegime) > 1;
    const isUseOfCFDIValid = Number(useOfCFDI) > 1;

    setIsSaveEnabled(allFieldsFilled && isTaxRegimeValid && isUseOfCFDIValid);
  }, [formData]);

  useEffect(() => {
    if (!showPifPopup && pifPopupHandled) {
      ReceiptOk();
      setPifPopupHandled(false);
    }
  }, [showPifPopup, pifPopupHandled]);

  /**PS_NO_AP_21
   * The sessionReload() method is used to reload the payment page
   * if the strore number is null or undefined
   */
  const sessionReload = () => {

    if (
      storeNumber == null ||
      storeNumber == CONSTANTS.NULL_STRING ||
      storeNumber == CONSTANTS.UNDEFINED_STRING ||
      storeNumber == undefined
    ) {
      window.sessionStorage.setItem(CONSTANTS.STORE_NUMBER, CONSTANTS.EMPTY_STRING);
      window.location.reload();
    } else {
      window.location.reload();
    }
  };

  /**PS_NO_AP_22- PS_NO_AP_23
   * The validateCappedFreeTime() used to check whether the customer takes payment by 
   * applying capped free time.
   */
  const validateCappedFreeTime = () => {
    if (featureFlags?.CappedFreeTimeEnabled == CONSTANTS.ONE_STRING) {
      const pendingAgr = agreementDetails.filter(
        (x) => x.numberOfPaymentsMade == CONSTANTS.ZERO_NUMBER && x.selected && x.storeNumber == storeNumber
      );
      const selectedAgreements = agreementDetails.filter((x) => x.selected && x.storeNumber == storeNumber);
      let totalExtensionAmount =
        pendingAgr.length > CONSTANTS.ZERO_NUMBER
          ? pendingAgr?.reduce(
            (total, obj) => total + Number(obj.extensionAmount || CONSTANTS.ZERO_NUMBER), CONSTANTS.ZERO_NUMBER
          )
          : CONSTANTS.ZERO_NUMBER;

      let selectedAgrTotalExtentionAmount =
        selectedAgreements.length > CONSTANTS.ZERO_NUMBER
          ? selectedAgreements?.reduce(
            (total, obj) => total + Number(obj.freeTimeAmountUsed || CONSTANTS.ZERO_NUMBER), CONSTANTS.ZERO_NUMBER
          )
          : CONSTANTS.ZERO_NUMBER;
      let amountUsed = Number(cappedFreeTimeDetails?.originalStoreRemainingBalance) - Number(selectedAgrTotalExtentionAmount) < 0 ? Math.abs(Number(cappedFreeTimeDetails?.originalStoreRemainingBalance) - Number(selectedAgrTotalExtentionAmount)) : 0;
      let storeRemainingAmount = Number(cappedFreeTimeDetails?.originalStoreRemainingBalance) - Number(selectedAgrTotalExtentionAmount) < 0 ? CONSTANTS.ZREO_TWO_DECIMAL_STRING : (Number(cappedFreeTimeDetails?.originalStoreRemainingBalance) - Number(selectedAgrTotalExtentionAmount)).toFixed(2);
      // setCappedFreeTimeDetails({...cappedFreeTimeDetails,storeRemainingAmount:Number(storeRemainingAmount),amountUsed:selectedAgrTotalExtentionAmount});
      if (
        Number(totalExtensionAmount) > Number(storeRemainingAmount) &&
        pendingAgr.some((x) => moment(x.openDate).isBefore(moment(), 'day'))
      ) {
        setExceededFreeTime(
          amountUsed +
          (Number(storeRemainingAmount) <= CONSTANTS.ZERO_NUMBER
            ? totalExtensionAmount
            : Number(storeRemainingAmount) - Number(totalExtensionAmount))
        );
        setFreeTimeAuthPopup({
          ...freeTimeAuthPopup,
          popup: true,
          secondFactor: false,
        });
      } else {
        setExceededFreeTime(amountUsed)
        setSecondFactorOpen(true);
        // setModuleName('Accept Payment');
      }
    } else {
      setSecondFactorOpen(true);
    }
  };

  // Generate Invoice Error Modal
  const InvoiceErrorMsgPopup = () => {
    return (
      <Grid item md={12}>
        <Grid item md={12} className={classes.textCenter}>
          <AlertIcon></AlertIcon>
          <Typography variant={"body2"} className={classes.RACPOPMsg}>
            {t(`the given receipt id is from the past month.`)}
          </Typography>
        </Grid>
        <Grid
          container
          className={`${classes.justifycontentcenter} ${classes.spacerMT4}`}
          style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}
        >
          <RACButton
            variant="contained"
            color="primary"
            isRounded={false}
            onClick={() => setInvoiceError(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  // handle generate invoice function
  const handleGenerateInvoice = async () => {
    const clientInvoice = "Y"
    try {
      setload(true);
      const finalResult = await generateInvoice(customerId, selectedReceipt, clientInvoice);
      console.log('final Result accept payment ', finalResult?.data?.errors?.[0]?.error);
      if (finalResult.status == 200) {
        setload(false);
        setInvoicePopup(true);
        const invoiceReceiptsTempArr = [...invoiceGenratedRcpts, { receiptId: selectedReceipt?.[0], status: true }];
        setInvoiceGenratedRcpts(invoiceReceiptsTempArr);
      }
      else if (finalResult.status == 400 && finalResult?.data?.errors?.[0]?.error == 'the given receipt id is from the past month') {
        setload(false);
        setInvoiceError(true);
      }
      else {
        setload(false);
        setErrorPoup(true);
      }
    } catch (error) {
      console.error('Error in invokePaymentAPI:', error);// Handle error (you can call an error callback if needed)
      setErrorPoup(true);
    } finally {
      setload(false);
      setIsPaymentHistory(false);
    }
  };
  /**PS_NO_AP_17 - PS_NO_AP_21
   * The function acceptPaymentOnclick() method is invoked when the user click the accept payment button
   */

  const handleCancel = () => {
    // Reset form data to initial values
    setOpenFacturaModalOne(false)
    setOpenFacturaModalTwo(false);
    acceptPaymentOnclick(true);
    isPaymentHistory ? handleGenerateInvoice() : acceptPaymentOnclick(true);
  };
  const acceptPaymentOnclick = (flag: boolean) => {
    if (
      storeNumber != CONSTANTS.EMPTY_STRING &&
      storeNumber != CONSTANTS.NULL_STRING &&
      storeNumber != null &&
      storeNumber != CONSTANTS.UNDEFINED_STRING
    ) {
      const selectedAgr = agreementDetails.filter(
        (x) => x.selected && x.storeNumber == storeNumber
      );
      const totalSuspenseUseAmount = selectedAgr.reduce(
        (total, obj) =>
          total + Number(obj.suspenseDetails.suspUse || CONSTANTS.ZERO_NUMBER),
        CONSTANTS.ZERO_NUMBER
      );
      const totalAmount = selectedAgr.reduce(
        (total, obj) =>
          total +
          (!obj?.isReturnAgreement
            ? Number(obj.totalDueAmount || CONSTANTS.ZERO_NUMBER)
            : CONSTANTS.ZERO_NUMBER),
        CONSTANTS.ZERO_NUMBER
      );

      /**
       * This variable is used to restrict SAC/PIF/EPO agreements before delivery confirmation.
       */
      const areNonEligibleSACAgreements: string[] = [];

      agreementDetails.forEach((ele: any) => {
        if (!ele?.deliveryFlag && CONSTANTS.NEXT_DUE_DATE_TYPE_ARRAY.includes(ele.nextDueDate) && ele.selected && ele?.agreementType != CONSTANTS.RESTITUTION) {
          areNonEligibleSACAgreements.push(ele);
        }
      })

      if (Number(totalSuspenseUseAmount) > Number(totalAmount) && flag) {
        setOpenSuspenseWithdraw(true);
      } else if (areNonEligibleSACAgreements?.length) {
        setIsDeliveryPopupOpen(true);
        setDeliveryNonConfirmedAgreements(areNonEligibleSACAgreements);
      }
      else {
        if (featureFlags?.RACExchange == CONSTANTS.ONE_STRING)
          exchangeAgreementValidation();

        isExceptionProvided();
        validateCappedFreeTime();
      }
    } else {
      setSessionExpiredPopupFlag(true);
    }
  };

  /**PS_NO_AP_23
   * The freeTimeAuthPopupContent() component is used to display the popup if the free time exceeds the current store free time.
   */
  const freeTimeAuthPopupContent = () => {
    return (
      <Grid className={`${classes2.textCenter}`} data-testid='free_time_auth_popup'>
        <AlertIcon />
        <Typography
          className={`${classesTwo.spacerMT3} ${classesTwo.customerRacpopup1}`}
        >
          {t("Allocated free time for this store has been exceeded. Do you still want to proceed ?")}
        </Typography>
        <Grid className={`${classesTwo.buttonsPadding}`}>
          <RACButton
            variant='outlined'
            color='primary'
            className={`${classesTwo.customerFloatleft}`}
            onClick={() => {
              setFreeTimeAuthPopup({ ...freeTimeAuthPopup, secondFactor: false, popup: false });
              setProceedButtonLoader(false);
            }}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            color='primary'
            variant='contained'
            data-testid='free_time_auth_popup_proceed'
            className={`${classesTwo.customerFloatright}`}
            onClick={() => {
              setFreeTimeAuthPopup({ ...freeTimeAuthPopup, secondFactor: true });
              //   setModuleName('CappedFreeTime')
              // setSecondFactorOpen(true);
              setProceedButtonLoader(true);
            }}
            loading={proceedButtonLoader}
          >
            {t("Proceed")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  /**PS_NO_AP_21
   * The buildSuspenseWithdraw() method id used to render the popup, if the customer uses the supence amount to pay the 
   * entire payment
   */
  const buildSuspenseWithdraw = () => {
    return (
      <Grid item className={classes.paymentmodal}>
        <Grid item md={12} className={classes.textcenter}>
          <Typography className='row justify-content-center popup-text' data-testId='overPayment_id'>
            {t("Customer is withdrawing from Suspense / Waiting for Signature")}
          </Typography>
        </Grid>
        <Grid item md={12} className={classes.textcenter}>
          <Grid className={classes.mt3}>
            <RACButton
              variant='contained'
              color='primary'
              className={classes.me2}
              onClick={() => {
                setOpenSuspenseWithdraw(false);
                acceptPaymentOnclick(false)
                // validateCappedFreeTime();
                //   setTwoFactorCompleted(false);
                //   setTwoFactorCancelClick(false);
                //   setSecondFactorOpen(true);
              }}
            >
              {t("OK")}
            </RACButton>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  /**PS_NO_AP_21
   * The sessionExpiredReloadPopup() method used to render the session reload popup.
   */
  const sessionExpiredReloadPopup = () => {
    return (
      <div>
        <Grid className={classes.textcenter} style={{ marginBottom: '22px' }}>
          <AlertIcon className={classes.racErrorIcon}></AlertIcon>
          <Typography className={classes.racErrorSessionFunction} data-testId='session_expiry'>
            {t("Your session has expired")}
          </Typography>
          <Typography className={classes.popUpTxtStyleSession} data-testId='Please_login'>
            {t("Please login again")}
          </Typography>
        </Grid>
        <Grid className={classes.textcenter} style={{ marginLeft: '3px' }}>
          <RACButton
            autoFocus
            variant='contained'
            color='primary'
            data-testid='session_ok_onclick'
            className={classes.me2}
            onClick={() => sessionReload()}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  /**PS_NO_AP_96
  The invokeReceiptParallel() method is used to fetch the receipt by making
  */
  const invokeReceiptParallel = async (finalResult: FinalResultArray[]) => {
    const isFailed: GetDocumentResponse[] = [];
    const isPassed: GetDocumentResponse[] = [];
    let totalFileList: ReceiptStatus[] = [];
    settxtChange(true);

    try {
      await Promise.all(
        finalResult.map(async (el) => {
          if (!el.isPaymentFailed) {
            const resultOfDoct: GetDocumentResponse = await getDocument(el.receiptID, 'RCP');
            resultOfDoct.data = resultOfDoct.data ?? ({} as any);
            resultOfDoct.data.storeNumber = el.storeNumber;
            resultOfDoct.data.receiptID = el.receiptID;

            const fileList = resultOfDoct.data?.fileList ?? [];

            if (resultOfDoct.status == 200 && fileList.length > 0 && fileList?.[0]?.fileObject !== null) {
              isPassed.push(resultOfDoct);
            } else {
              isFailed.push(resultOfDoct);
            }
          } else {
            totalFileList.push({
              documentURL: CONSTANTS.EMPTY_STRING,
              storeNumber: el.storeNumber,
              isPaymentFailed: true,
            });
          }
        })
      );

      if (isFailed.length && receptFailedAttempts < 10) {
        receptFailedAttempts = receptFailedAttempts + CONSTANTS.ONE_NUMBER;
        await invokeReceiptParallel(finalResult);
      } else {
        const combinedData = [...isPassed, ...isFailed];
        combinedData.forEach((el) => {
          const fileList = el.data?.fileList ?? [];

          if (el.status == 200 &&
            Object.keys(el.data || {}).length > CONSTANTS.ONE_NUMBER &&
            fileList?.[0]?.fileObject !== null
          ) {

            const cooRecord = fileList.filter((x) => x.docType === CONSTANTS.RECEIPT_TYPE_COOS);
            const receiptRecord = fileList.filter((x) => x.docType === CONSTANTS.RECEIPT_TYPE_PRCT);
            const Extrecord = fileList.filter((x) => x.docType === CONSTANTS.RECEIPT_TYPE_EXTRF);

            if (fileList.length !== CONSTANTS.ZERO_NUMBER) {
              if (receiptRecord.length != CONSTANTS.ZERO_NUMBER) {
                receiptRecord.forEach((file) => {
                  const type = getContentType(file?.fileName);
                  const formatedURL = URL.createObjectURL(b64toBlob(file?.fileObject, type));
                  totalFileList.push({
                    documentType: CONSTANTS.RECEIPT_TYPE_PRCT,
                    documentURL: formatedURL,
                    receiptID: el.data.receiptID,
                    storeNumber: el.data.storeNumber ?? CONSTANTS.EMPTY_STRING,
                    isPaymentFailed: false,
                    isLoading: false,
                  });
                });
              }

              if (cooRecord.length != CONSTANTS.ZERO_NUMBER) {
                cooRecord.forEach((file) => {
                  const type = getContentType(file?.fileName);
                  const formatedURL = URL.createObjectURL(b64toBlob(file?.fileObject, type));
                  totalFileList.push({
                    documentType: CONSTANTS.RECEIPT_TYPE_COOS,
                    documentURL: formatedURL,
                    receiptID: el.data.receiptID,
                    storeNumber: el.data.storeNumber ?? CONSTANTS.EMPTY_STRING,
                    isPaymentFailed: false,
                    isLoading: false,
                  });
                });
              }

              if (Extrecord.length != CONSTANTS.ZERO_NUMBER) {
                Extrecord.forEach((file) => {
                  const type = getContentType(file?.fileName);
                  const formatedURL = URL.createObjectURL(b64toBlob(file?.fileObject, type));
                  totalFileList.push({
                    documentType: CONSTANTS.RECEIPT_TYPE_EXTRF,
                    documentURL: formatedURL,
                    receiptID: el.data.receiptID,
                    storeNumber: el.data.storeNumber ?? CONSTANTS.EMPTY_STRING,
                    isPaymentFailed: false,
                    isLoading: false,
                  });
                });
              }
            }
          } else {
            totalFileList.push({
              documentType: CONSTANTS.EMPTY_STRING,
              documentURL: CONSTANTS.EMPTY_STRING,
              storeNumber: el.data.storeNumber ?? CONSTANTS.EMPTY_STRING,
              isPaymentFailed: false,
              isLoading: false,
            });
          }
        });
        receptFailedAttempts = CONSTANTS.ZERO_NUMBER;
      }
      if (totalFileList?.length > 0) {
        totalFileList = totalFileList.sort((a, b) => {
          // Assuming receiptID is a string, use localeCompare for proper string comparison
          return Number(a?.receiptID ?? 0) - Number(b?.receiptID ?? 0);
        })
      }

      setreceiptResultArray({
        ...receiptResultArray,
        totalFileList: totalFileList,
        cooArray: totalFileList.filter((x) => x.documentType == CONSTANTS.RECEIPT_TYPE_COOS),
        extentionArray: totalFileList.filter((x) => x.documentType == CONSTANTS.RECEIPT_TYPE_EXTRF)
      });
    } catch (error) {
      console.error('Error in invokeReceiptParallel:', error);
    } finally {
      settxtChange(false);
    }
  };

  /** The groupAgreementsByStore() method is used to form the object which accumulate the agreements in array
  against the respective store number
  */
  const groupAgreementsByStore = (agreements: AgreementDetails[]) => {
    return agreements.reduce((group, agreement) => {
      const { storeNumber } = agreement;
      group[storeNumber] = group[storeNumber] || [];
      group[storeNumber].push(agreement);
      return group;
    }, {});
  };

  /**The createProcessOrderData() method is used to form the payload for the customerOrder prilim/initial payment 
  */
  const createProcessOrderData = (coPrelimDetails: CoPrelimDetails) => {
    // const { provideEAFlag, provideAgrNumberPO, providePOAddressData, providePlaceOrderItemData } = customerInfo?.coPrelimDetails;
    const processOrderData: PlaceOrderDetails = {
      eaFlag: coPrelimDetails?.provideEAFlag ?? CONSTANTS.EMPTY_STRING,
      agreementNumber: coPrelimDetails?.provideAgrNumberPO ?? CONSTANTS.EMPTY_STRING,
    };

    if (coPrelimDetails?.provideEAFlag == CONSTANTS.YES) {
      processOrderData.shippingAddress = coPrelimDetails?.providePOAddressData;
      processOrderData.items = [coPrelimDetails?.providePlaceOrderItemData];
    }

    return processOrderData;

  }

  /** PS_NO_AP_29 -  The invokePaymentAPI() method is invoked once all the validation is completed */
  const invokePaymentAPI = async () => {
    let entireAcceptPayAPIArray: TakePaymentRequest[] = [];
    let processOrderData: PlaceOrderDetails;
    const selectedAgreements: AgreementDetails[] = agreementDetails.filter((x) => x.selected);
    const groupByStoreNumber = groupAgreementsByStore(selectedAgreements);
    const keys = Object.keys(groupByStoreNumber);
    let clientInvoice: string | undefined
    if (featureFlags.EnableFactura == '1') {
      clientInvoice = (facturaDetails?.[0]?.invoiceReq === "1" ||
        (facturaDetails?.[0]?.invoiceReq === "0" && popupData) ||
        secondPopupData) ? 'Y' : 'N';
    }

    const spendLimitId = urlParams.get(CONSTANTS.URLPARAMS_SPEND_LIMIT_ID);
    if (coPrelimDetails && customerOrderPayment == CONSTANTS.IS_CO_PRELIM && !spendLimitId) {
      processOrderData = createProcessOrderData(coPrelimDetails);
    }

    const isEmailNotify =
      Number(featureFlags.MaxReceiptsEmailable) > 0 &&
        ['PREM', 'EM'].includes(customerInfo.printReceiptMethod)
        ? 'Y'
        : 'N';

    entireAcceptPayAPIArray = await Promise.all(keys.map(async (key) => {
      collectStoreNumber.push(groupByStoreNumber[key][0].storeNumber);
      return CreatePaymentInfoForPayload(groupByStoreNumber[key], processOrderData, key, undefined, {
        customerId,
        agreementDetails,
        customerInfo,
        multiStoreSelected,
        featureFlags,
        paymentOrigin,
        coWorkerDetails,
        storeInfo,
        exceededFreeTime,
        cappedFreeTimeDetails,
        isEmailNotify,
        clientInvoice,
        customerOrderPayment
      }, undefined, paymentWithdrawCheckbox, featureFlags?.MXSuspense?.toString() ?? '0');
    }));

    try {
      const finalResult: FinalResultArray[] = await processPayments(entireAcceptPayAPIArray);
      setReceiptID(finalResult.filter((x) => x.storeNumber == storeNumber)[0]?.receiptID);
      handlePaymentResults(finalResult);

      if (storeExceptionRequest.length > CONSTANTS.ZERO_NUMBER && !finalResult.filter((x) => x.storeNumber == storeNumber)[0]?.isPaymentFailed) {
        const requestForStoreException = storeExceptionPayloadFormation(entireAcceptPayAPIArray[0], finalResult);
        storeException(requestForStoreException);
      }
    } catch (error) {
      console.error('Error in invokePaymentAPI:', error);
      setTransactionFail(true);
      setload(false);
    }
  };
  /**The processPayments() is invoked to make the api call for taking the payment */
  const processPayments = async (paymentInfoArray: TakePaymentRequest[]) => {

    const results = await Promise.all(paymentInfoArray.map(async (paymentInfo: TakePaymentRequest, index: number) => {
      const result = await ProcessPaymentAPI(paymentInfo);
      return handlePaymentResult(result, paymentInfo, index);
    }));
    return results.flat()
  };

  /**The handlePaymentResult() method is used to handle the process payment responce once the payment completed*/
  const handlePaymentResult = (result, paymentInfo: TakePaymentRequest, index: number) => {

    if (result.status === 200) {
      if (!multiStoreSelected)
        settran(true);

      handlePostAgreementActivity(paymentInfo);
      if (exchangedAgreementArray.length > 0 && featureFlags?.RACExchange == CONSTANTS.ONE_STRING)
        unEnrollAutoPay();

      return handleSuccessfulPayment(result, index);
    } else {
      return handleFailedPayment(result, index);
    }
  };

  /** The handleSuccessfulPayment() method is used to form the array containing objec with receiptId along with the store
   to show the successfull payment status in the popup if its different stor payment is done */
  const handleSuccessfulPayment = (result, index: number) => {

    return result.data.receiptInfo.map(rcpel => ({
      storeNumber: collectStoreNumber[index],
      receiptID: rcpel.receiptId,
      isPaymentFailed: false,
    }));

  };


  const handleFailedPayment = (result, index: number) => {
    if (!multiStoreSelected) {
      handleSingleStoreFailure(result);
    }
    return {
      storeNumber: collectStoreNumber[index],
      receiptID: CONSTANTS.EMPTY_STRING,
      isPaymentFailed: true,
    };
  };

  /**
   * The handleSingleStoreFailure() function is used to handle the payment failure while making the payment for single store
   */
  const handleSingleStoreFailure = (result) => {
    const storeErrorMessage = result?.data?.errors[0]?.error?.message;
    if (storeErrorMessage && storeErrorMessage.includes(CONSTANTS.AMOUNT_MISMATCH)) {

      setIsAmountMismatch(true);
    } else if (result.status == 400 && result.data?.errors[0]?.error?.serviceResponse?.Body?.StatusInfo?.StatusCodeDetail) {

      let declineCode = result?.data?.errors[0]?.error?.serviceResponse?.Body?.declineCode;
      const internalStatusCode = result?.data?.errors[0]?.error?.serviceResponse?.Body?.StatusInfo?.statusCode;
      if (internalStatusCode === 'DP') {
        declineCode = 712;
      }
      const cardDeclineMessage = CONSTANTS.CARD_DECLINE_MESSAGE[Number(declineCode)] || CONSTANTS.CARD_DECLINE_MESSAGE[13];
      setCardPaymentFailedMessage(t(cardDeclineMessage));
      setTransactionFail(true);


    }
    else {
      setTransactionFail(true);
      setCardPaymentFailedMessage(CONSTANTS.EMPTY_STRING);
    }
    // Handle decline codes if necessary
  };

  /**
   * The handlePaymentResults() method is triggered once the payment is taken successfully and the receipt is fetched 
   * and the status popup is shown based on the selected agreement store.
   * @param finalResult 
   */
  const handlePaymentResults = (finalResult: FinalResultArray[]) => {
    const receiptConditionData = finalResult.map(el => ({
      documentType: CONSTANTS.EMPTY_STRING,
      documentURL: CONSTANTS.EMPTY_STRING,
      storeNumber: el.storeNumber,
      receiptID: el.receiptID,
      isPaymentFailed: el.isPaymentFailed,
      isLoading: true,
    }))?.sort((a, b) => {
      return a.receiptID.localeCompare(b.receiptID);
    });
    receiptResultArray = { ...receiptResultArray, totalFileList: receiptConditionData }
    setreceiptResultArray(receiptResultArray);
    invokeReceiptParallel(finalResult);
    setInitialReceiptStatus(receiptConditionData);
    setFinalPaymentResult(finalResult);
    // setInitialReceiptStatus(receiptConditionData);
    // setreceiptResultArray(receiptConditionData);

    if (multiStoreSelected) {
      const paymentAPIResult = finalResult.map(el => ({
        storeNumber: el.storeNumber,
        transactionStatus: el.isPaymentFailed ? CONSTANTS.PAYMENT_FAILED : CONSTANTS.PAYMENT_PASSED,
      }));
      settransactionResultArray(paymentAPIResult);
      setShowPaymentStatus(true);
      setload(false);
    }
    else {
      // settran(true);
      setload(false);
    }


  };

  /**
   * The handlePostAgreementActivity() method is used to post the postAgreementActivity, it is done only the
   * retention EPO or the retention free time is done.
   * @param paymentInfo 
   */
  const handlePostAgreementActivity = async (paymentInfo: TakePaymentRequest) => {
    if (retentionType && paymentInfo?.paymentInfo && paymentInfo?.paymentInfo.length > CONSTANTS.ZERO_NUMBER && paymentInfo?.paymentInfo[0].agreementPayment) {
      const agreementIdRetention = location?.state[CONSTANTS.RETENTION_DATA] ? location?.state[CONSTANTS.RETENTION_DATA]?.agreementId : CONSTANTS.EMPTY_STRING;
      if (agreementIdRetention) {
        const today = new Date().toISOString().split('T')[0];

        const filterApplied = paymentInfo?.paymentInfo[0]?.agreementPayment?.filter(
          (el) =>
            el.agreementId == agreementIdRetention &&
            (el.freeTime !== null || el.epoPayment !== CONSTANTS.STATUS_YES)
        ) ?? [];

        if (filterApplied.length) {
          const { agreementId, freeTime } =
            filterApplied[0];
          const activityPayload = {
            agreementActivities: [
              {
                activityDate: today,
                agreementId: agreementId,
                activityDescription:
                  freeTime !== null
                    ? CONSTANTS.RETENTION_FREETIME
                    : CONSTANTS.RETENTION_EPO,
                agreementActivityType:
                  freeTime !== null ? CONSTANTS.RETENTION_TYPE[0] : CONSTANTS.RETENTION_TYPE[1],
              },
            ],
          };

          await postAgreementActivity(activityPayload);
        }
      }
    }
  }

  if (redirectToAccountManagement) {
    const urlParams = new URLSearchParams(window.location.search);
    const retentionType = urlParams.get('CRTYPE');
    if (retentionType) {
      return (
        <Redirect
          to={{
            pathname: `/am/customer/${customerId}`,
            state: {
              ...(location?.state || {}),
              redirectSource: 'payment',
            },
          }}
        />
      );
    } else {
      return (
        <Redirect
          to={{
            pathname: AppRoute.AccountManagement.replace(
              ':customerId',
              location?.state?.accountManagementCustomerId || customerId || ''
            ),
            state: {
              ...(location?.state || {}),
              redirectSource: 'payment',
            },
          }}
        />
      );
    }
  }

  /**
   * The customerDocGen() method is used to form the paylod make the api call to generate the document for getting sign from 
   * the during, club creation and the agreement convert into the note payment
   * @param options 
   */
  const customerDocGen = async (options: {
    isClub: boolean;
    agreementId?: number;
  }) => {
    const { isClub, agreementId } = options;

    const generateDocPayload = {
      identifier: isClub ? Number(customerId) : Number(agreementId),
      identifierType: isClub ? 'CUST' : CONSTANTS.AGR.toUpperCase(),
      signingUrlRequired: false,
      signers: [
        {
          customerId: String(customerId),
          customerName: `${customerInfo.customerDetails[0].firstName}${CONSTANTS.STRING_WITH_SINGLE_SPACE}${customerInfo.customerDetails[0].lastName}`,
          phoneNumber: String(customerInfo.customerDetails[0]?.phoneNumber),
          emailId: String(customerInfo.customerDetails[0].emailAddress),
          priority: CONSTANTS.ONE_NUMBER,
        },
      ],
      signatureType: CONSTANTS.ONE_NUMBER,
      isRemote: false,
      manualSignatureReasonId: null,
      documentType: isClub
        ? [CONSTANTS.CLUB_SMALL_CASE.toUpperCase()]
        : CONSTANTS.CUSTOMER_SIGNAETURE_INSTALLMENT_ARR,
      returnURL: window.location.origin,
    };

    await GenerateAgreementDoc(generateDocPayload);
    setclubSignFlow(true);
  };
  /**
   * The installmentAgrSignFlow() method is used to open the customer signaeture popup
   */
  const installmentAgrSignFlow = (installmentInfo: AgreementDetails[]) => {
    for (let i = 0; i < installmentInfo?.length; i++) {
      customerDocGen({ isClub: false, agreementId: Number(installmentInfo[i].agreementId) })
      setPifAgreementID(installmentInfo[i].agreementId);
      setCustomerSignUsingField({
        ...customerSignUsingField,
        field: CONSTANTS.AGREEMENT_DETAILS,
        documentType: CONSTANTS.CUSTOMER_SIGNAETURE_INSTALLMENT_ARR[0],
      });
      setcustomerSignaturePopup(true);
      setrecpt(false);
    }
  };

  /**
   * PS_NO_AP_102 - PS_NO_AP_106
   * The redirectionFunc() method is triggered when the ok button is clicked in the receipt popup,
   * this function helps to route the page based on the page logined.
   * @param flag 
   */
  const redirectionFunc = (flag: boolean) => {
    setShowReceiptStatus(false);
    const getUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const retentionType = urlParams.get(CONSTANTS.URLPARAMS_CRTYPE) ?? CONSTANTS.EMPTY_STRING;
    const retentionSource = urlParams.get(CONSTANTS.URLPARAMS_SRCTYPE) ?? CONSTANTS.EMPTY_STRING;
    if (Number(agreementId) > CONSTANTS.ZERO_NUMBER && getUrl.includes('/customerorder/initial/')) {
      history.push({
        pathname: `/agreement/info/details/${customerId}/${agreementId}`,
      });
    } else if (
      Number(agreementId) > CONSTANTS.ZERO_NUMBER &&
      getUrl.includes('/customerorder/preliminary/')
    ) {
      history.push({
        pathname: `/agreement/customerorder/postatus/${customerId}/${agreementId}`,
      });
    } else if (Number(agreementId) > CONSTANTS.ZERO_NUMBER) {
      history.push({
        pathname: `/agreement/rental/delivery/${customerId}/${agreementId}`,
      });
    } else if (agreementDetails.some((x) => x.selected && x.isCommitmentTaken) && !flag) {
      setrecpt(false);
      setopenCommitmentConfirmation(true);
    } else if (location?.state?.redirectSource === CONSTANTS.AM) {
      setRedirectToAccountManagement(true);
    } else if (retentionType && retentionSource == undefined) {
      setRedirectToAccountManagement(true);
    } else if (retentionType && retentionSource == CONSTANTS.PAYMENT.toUpperCase()) {
      history.push({
        pathname: `/payment1/paymentinformation/${customerId}/${agreementId}`,
      });
      window.location.reload();
    } else {
      window.location.reload();

    }
  };


  const exchangeAgreementValidation = () => {
    const isAutoPayEnrolledParentAgreement = agreementDetails.filter(
      (x) => x.isExchanged
    );
    const exchangeAgreementArray = agreementDetails
      .filter((x) => x.selected && x.agreementStatus == CONSTANTS.AGREEMENT_STATUS_ACTIVE_PEND[1] && x.parentAgreementId)
      ?.reduce((acc: Array<{ agreementId: string; agreementNumber: string; childrenAgreementId: string; isAutoPayEnrolled: boolean; }>, x) => {
        const parentAgreement = isAutoPayEnrolledParentAgreement.find(
          (el) => el.agreementId == x.parentAgreementId
        );

        if (parentAgreement) {
          acc.push({
            agreementId: x.parentAgreementId ?? CONSTANTS.EMPTY_STRING,
            agreementNumber: parentAgreement.agreementNumber || CONSTANTS.EMPTY_STRING,
            childrenAgreementId: x.agreementId,
            isAutoPayEnrolled: parentAgreement.isAutopayEnroll ? true : false
          });
        }

        return acc;
      }, []);
    exchangedAgreementArray = exchangeAgreementArray
    setExchangeAgreementArray(exchangedAgreementArray);


  };

  async function unEnrollAutoPay() {
    let agreementArray: string[] = [];
    try {
      if (exchangedAgreementArray?.length) {
        exchangedAgreementArray?.forEach((element) => {
          if (element?.isAutoPayEnrolled)
            agreementArray.push(element?.agreementId?.toString());
        })
        if (agreementArray.length > 0) {
          UnEnrollAutoPay({
            autopayFlag: CONSTANTS.ZERO_NUMBER,
            agreementIds: agreementArray
          });
        }
      }
    }
    catch (e) {
      console.log(e, 'Error in Catch');
      //catch handle
    }
  }

  const openAutoPayPopup = () => {//RAC2

    const autoPayEnrolledParentAgreement = exchangedAgreementArray.filter((el) => el.isAutoPayEnrolled);
    return (
      <Grid className={`${classes2.textCenter}`}>
        <Typography className={`${classesTwo.spacerMT3} ${classesTwo.customerRacpopup2}`}>
          {t("Autopay will be un-enrolled for the Exchanged agreement")}  {autoPayEnrolledParentAgreement?.length > 0 ? autoPayEnrolledParentAgreement?.map((element: ExchangeAgreementArray) => element?.agreementNumber)?.join(', ')?.length > 25 ? autoPayEnrolledParentAgreement?.map((element: ExchangeAgreementArray) => element?.agreementNumber)?.join(', ')?.slice(0, 20) + '...' : autoPayEnrolledParentAgreement?.map((element: ExchangeAgreementArray) => element?.agreementNumber)?.join(', ') : exchangeAgreementId}.
        </Typography>
        <Typography className={`${classesTwo.mt11} ${classesTwo.customerRacpopup3}`}>
          {t("Does the customer want to enroll in autopay for the New Agreement?")}
        </Typography>
        <Grid className={`${classesTwo.buttonsPadding} ${classesTwo.centerButton}`}>
          <RACButton
            variant="outlined"
            color="primary"
            className={`${classesTwo.customerFloatleft} ${classesTwo.mr15px}`}
            onClick={() => {
              setAutoPayConfirmationPopup(false);
              history.push(`/agreement/rental/delivery/${customerId}/${agreementId}?exagreementid=${exchangeAgreementId}`)
            }}
          >
            {t("No")}
          </RACButton>
          <RACButton
            color="primary"
            variant="contained"
            className={`${classesTwo.customerFloatright}`}
            onClick={() => setRacExchangeAutoPayPopup(true)}
            loading={proceedButtonLoader}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    )
  }

  const checkPifConditions = (agreements) => {
    const currentDate = new Date();
    console.log(agreements, 'agreements in current store');

    // Selected agreements for the current store
    const selectedAgreements = agreementDetails.filter(
      (x) => x.selected && x.storeNumber == storeNumber
    );

    const isFinalPayment = selectedAgreements.some(
      (agreement) => agreement.isFinalPayment === 'PIF' || agreement.isFinalPayment === 'EPO' || agreement.isFinalPayment === 'SAC' || agreement.isFinalPayment != ''
    );

    console.log(isFinalPayment, 'isfinalPayment')
    // Find an agreement that matches all final payment conditions
    const finalPaymentAgreement = selectedAgreements.find((agreement) => {
      if (
        (agreement.agreementType === 'EPO Rent' || agreement.agreementType === 'PIF Rent') &&
        isFinalPayment &&
        agreement.pifDate
      ) {
        const pifDate = new Date(agreement.pifDate);
        const daysUntilPif = Math.ceil((pifDate - currentDate) / (1000 * 60 * 60 * 24));
        return daysUntilPif >= 0 && daysUntilPif <= 90;
      }
      return false;
    });
    console.log(finalPaymentAgreement, 'finalPaymentAgreement')

    if (finalPaymentAgreement) {
      // Check if any new agreements were created within 90 days of the final payment PIF date
      const finalPifDate = finalPaymentAgreement.pifDate ? new Date(finalPaymentAgreement.pifDate) : new Date();
      const rangeStart = new Date(finalPifDate.getTime() - 90 * 24 * 60 * 60 * 1000);

      const hasNewAgreementInRange = agreements.some((agreement) => {
        const openDate = new Date(agreement.openDate);
        return openDate >= rangeStart && openDate <= finalPifDate;
      });


      // Only show popup if no new agreements were created in the 90-day window
      if (!hasNewAgreementInRange) {
        console.log('inside final payment pop up')
        setShowPifPopup(true);
        setDaysToPif(0);
        setPopupContentType('finalPayment');
        return true;
      } else {
        setShowPifPopup(false);
        return false;
      }
    }

    // Filter agreements to get those with pifDates within 90 days from current date
    const pifAgreements = agreements.filter((agreement) => {
      const pifDate = new Date(agreement.pifDate);
      const daysUntilPif = Math.ceil((pifDate - currentDate) / (1000 * 60 * 60 * 24));
      console.log(daysUntilPif, 'daysUntilPif');
      return daysUntilPif > 0 && daysUntilPif <= 90;
    });
    console.log(pifAgreements, 'pifagreement list');

    if (pifAgreements.length >= 1) {
      // Sort pif agreements by pifDate to find the closest ones
      pifAgreements.sort((a, b) => new Date(a.pifDate) - new Date(b.pifDate));

      // Check for open agreements that fall within 90 days before the closest pifDate
      const newAgreements = agreements.filter((agreement) => {
        const openDate = new Date(agreement.openDate);
        return openDate >= new Date(pifAgreements[0].pifDate) - 90 * 24 * 60 * 60 * 1000 && // 90 days before pifDate
          openDate <= new Date(pifAgreements[0].pifDate); // up to pifDate
      });

      console.log(newAgreements, 'new agreements with pif agreements');
      console.log('new agreement count', newAgreements);

      // Logic for showing the popup
      const pifCount = pifAgreements.length;
      const openCount = newAgreements.length;
      console.log('pifcount', pifCount, 'open count', openCount);

      // Case where there are more open agreements than PIF agreements
      if (openCount > pifCount) {
        setShowPifPopup(false);
        return false;
      }
      // if open and pif count is same then no pop up
      else if (openCount === pifCount) {
        setShowPifPopup(false);
        return false;
      }
      // Case where there are more PIF agreements than open agreements
      else {
        const closestPIFIndex = openCount; // This will point to the next PIF agreement to show popup for
        if (closestPIFIndex < pifCount) {
          const closestAgreement = pifAgreements[closestPIFIndex];
          setDaysToPif(Math.ceil((new Date(closestAgreement.pifDate) - currentDate) / (1000 * 60 * 60 * 24)));
          setShowPifPopup(true);
          setPopupContentType('default');
          return true;
        }
      }
    }

    setShowPifPopup(false);
    setPopupContentType('default');
    return false; // No popup, continue workflow
  };

  /**
   * PS_NO_AP_100 - PS_NO_AP_102
   * The ReceiptOk() method is invoked when the ok button is clicked in the receipt popup,
   * this function helps to route the page based on the page logined.
   */

  const flaged = false

  const ReceiptOk = async () => {
    setrecpt(false);
    const getUrl = window.location.href;
    console.log(getUrl, 'url of ths ')
    if (getUrl.includes(`/payment1/paymentinformation/${customerId}/0`)) {
      console.log(getUrl, 'url inside the if')
      if (featureFlags.EnablePrePIFNotification == CONSTANTS.ONE_STRING && !pifPopupHandled && flaged) {
        const currentStoreAgreements = agreementDetails.filter(
          (agreement) => agreement.storeNumber === storeNumber
        );

        const popupTriggered: any = checkPifConditions(currentStoreAgreements);
        console.log('outside popuptriggered', popupTriggered)
        if (popupTriggered) {
          console.log('inside popuptriggered', popupTriggered)
          return;
        }
        setPifPopupHandled(true);
      }
    }
    if (featureFlags.ActivateClub == CONSTANTS.ONE_STRING) {
      // Get the selected non-club agreement (e.g., CO preliminary payment agreement)
      const selectedNonClubAgreement = agreementDetails.find(
        (x: AgreementDetails) => x.selected && x.agreementType !== CONSTANTS.CLUB
      );

      const clubInformation = agreementDetails.filter(
        (x: AgreementDetails) => x.agreementType == CONSTANTS.CLUB
      );

      // Filter clubs: only for CO Preliminary Payment - use existing selectedNonClubAgreement from scope
      const shouldFilterClubs = customerOrderPayment === CONSTANTS.IS_CO_PRELIM;
      const filteredClubInformation = shouldFilterClubs
        ? clubInformation.filter(club => 
            !club.originAgreementId || String(club.originAgreementId) === selectedNonClubAgreement?.agreementId
          )
        : clubInformation;

      const installmentInfo = agreementDetails.filter(
        (x: AgreementDetails) =>
          x.selected &&
          (x.agreementType == 'PIF Rent' ||
            (x.agreementType == CONSTANTS.EPO_RENT && x?.acceptEpoFlag == 0 && !(x?.isOverSus || x?.isExactSus || x?.isEPOSusAmtDue)) ||
            (x.isAdjustDuedateEdit && x.agreementType == CONSTANTS.EPO_RENT && x?.acceptEpoFlag == 0 && !(x?.isOverSus || x?.isExactSus || x?.isEPOSusAmtDue)) ||
            (x.isEditScheduleEdited && x.agreementType == CONSTANTS.EPO_RENT && x?.acceptEpoFlag == 0 && !(x?.isOverSus || x?.isExactSus || x?.isEPOSusAmtDue))) &&
          x.isNoteAgreement == CONSTANTS.STATUS_YES
      );
      const clubFlag = agreementDetails.filter(
        (x: AgreementDetails) => x.agreementType == CONSTANTS.CLUB && x.selected
      );

      if (
        filteredClubInformation[0] == undefined
          ? false
          : (filteredClubInformation[0].clubDocumentSignStatus == null ||
            filteredClubInformation[0].clubDocumentSignStatus == CONSTANTS.UK) &&
          filteredClubInformation[0].originAgreementId == null &&
          clubFlag.length > 0 &&
          filteredClubInformation[0]?.numberOfPaymentsMade == CONSTANTS.ZERO_NUMBER &&
          receiptResultArray?.totalFileList?.some((x) => x.storeNumber == filteredClubInformation[0]?.storeNumber && x.isPaymentFailed == false)
      ) {
        customerDocGen({ isClub: true });
        setCustomerSignUsingField({
          ...customerSignUsingField,
          field: 'club',
          documentType: 'CLUB',
        });
        setcustomerSignaturePopup(true);
        setrecpt(false);
      } else if (receiptResultArray?.totalFileList?.some((x) => x.storeNumber == installmentInfo[0]?.storeNumber && x.isPaymentFailed == false) && installmentInfo?.length > CONSTANTS.ZERO_NUMBER) {
        installmentAgrSignFlow(installmentInfo);
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const returnType = urlParams.get('type');
        if (returnType == 'RETURN' || returnType == 'CHRGOFF') {
          const returnAGRParamValue: string = urlParams.get('agreementId') ?? CONSTANTS.EMPTY_STRING;
          if (Number(returnAGRParamValue) > 0) {
            history.push({
              pathname: `/agreement/info/details/${customerId}/${returnAGRParamValue}`,
              search: `?type=${returnType}`,
            });
          }
        }
        else {
          redirectionFunc(false);
        }
      }
    } else {
      redirectionFunc(false);
    }
  };

  const transactioncompletedPopup = () => {
    return (
      <Grid
        item
        data-testid='transaction_completed'
        id='transatraction'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex={-1}
        aria-labelledby='transaction'
        aria-hidden='true'
      >
        <Grid item md={12} className={classes.textcenter}>
          <SuccessIcon></SuccessIcon>
          <Typography
            className={`${classes.modalfooter} ${classes.textcenter} ${classes.w100} ${classes.mt3}`}
          >
            {t("Transaction completed successfully")}
          </Typography>
        </Grid>

        <Grid
          item
          md={12}
          className={`${classes.modalfooter} ${classes.textcenter} ${classes.mt3}`}
        >
          <RACButton
            className={classes.mx1}
            data-testid='transaction_completed_ok'
            color='primary'
            variant='contained'
            data-bs-dismiss='modal'
            data-bs-toggle='modal'
            onClick={() => {
              setrecpt(true);
              settran(false);
              if (featureFlags.MXStoreIdentifier === "1" && featureFlags.MXBarcodeTenderType === '1') {
                const barcodeAgreements = agreementDetails.filter((x) => x.selected && x.storeNumber == storeNumber && (x.isLDWActionPerformed === "Y" || x.isLDWActionPerformed === "N" || x.isEditScheduleEdited || x.agreementStatus == "PEND" || x.agreementStatus == "PRELIMINV"));
                setBarcodeAgreements(barcodeAgreements);
              }
            }}
            data-bs-target='#delivery-receipt'
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const commitmentConfirmation = () => {
    return (
      <Grid>
        <Grid className={classes.textCenter} data-testid='commitmentId'>
          <Typography className={`${classes.bold} ${classes.titletxtstyle}`}>
            {t("Do you want to take recommitment ?")}
          </Typography>
        </Grid>
        <Grid
          container
          className={`${classes.justifyContentCenter} ${classes.mt4}`}
        >
          <RACButton
            className={`${classes.me2}`}
            size='small'
            variant='outlined'
            color='primary'
            data-testid='commitment_no'
            isRounded={false}
            onClick={() => { redirectionFunc(true) }}
          >
            {t("No")}
          </RACButton>
          <RACButton
            size='small'
            variant='contained'
            color='primary'
            onClick={() => {
              history.push({
                pathname: `/am/customer/${customerId}`,
                search: `?type=RECOMMIT`,
              });
            }}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const transantionFailedPopup = () => {
    return (
      <div>
        <Grid className={classes.textcenter} data-testid='transaction_failed'>
          <AlertIcon className={classes.racErrorIcon}></AlertIcon>
          {cardPaymentFailedMessage == CONSTANTS.EMPTY_STRING ? (
            <Typography className={classes.racErrorFunction}>
              {t("Transaction has been failed")}
            </Typography>
          ) : cardPaymentFailedMessage !== CONSTANTS.EMPTY_STRING ?
            <Typography className={classes.racErrorFunction}>
              {cardPaymentFailedMessage}
            </Typography> : null}

        </Grid>
        <Grid className={classes.textcenter}>
          <RACButton
            autoFocus
            variant='contained'
            color='primary'
            className={classes.me2}
            onClick={okClickUnavailable}
            data-testid='transaction_failed_ok'
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const extensionReceipt = () => {
    return receiptResultArray?.extentionArray?.map((value: ReceiptStatus, index: number) => {
      return (
        <>
          <Typography className={`${classes.colmd12} ${classes.mb2}`} >
            {t("Extension Receipt Form:")}{CONSTANTS.STRING_WITH_SINGLE_SPACE}
            <a
              onClick={() => {
                setextIndex(index);
                setviewExtPopup(true);
              }}
              data-testid='extensionId'
              style={{
                textDecoration: 'underline',
                color: '#2179FE',
                cursor: 'pointer',
              }}
              className={`${classes.mt3}${classes.me3} ${classes.ms2} ${classes.popUpTxtStyle} ${classes.ms1}`}
            >
              {t("View")}
            </a>
          </Typography>
        </>
      );
    });
  };
  {/** cofReceipt() method used to render the UI of certi ficate of owner ship popup*/ }
  const cofReceipt = () => {

    return receiptResultArray.cooArray.map((value: ReceiptStatus, index: number) => {
      return (
        <>
          <Typography className={`${classes.colmd12} ${classes.mb2}`}>
            {t("Certificate of Ownership")}:
            <a
              onClick={() => {
                setcofIndex(index);
                setviewCOFPopup(true);
              }}
              style={{
                textDecoration: 'underline',
                color: '#2179FE',
                cursor: 'pointer',
              }}
              data-testid='cofId'
              className={`${classes.mt3}${classes.me3} ${classes.ms2} ${classes.popUpTxtStyle} ${classes.ms1}`}
            >
              {t("View")}
            </a>
          </Typography>
        </>
      );
    });
  };
  const MxReceiptpopup = () => {

    const receiptStatus = receiptResultArray?.totalFileList?.filter((x) => x?.documentType == 'PRCT' || x.documentType == '');
    return (
      <>
        <Grid
          item
          id='delivery-receipt'
          data-bs-backdrop='static'
          data-bs-keyboard='false'
          tabIndex={-1}
          aria-labelledby='autopayconsent'
          aria-hidden='true'
          data-testid='receiptIdPopup'
        >
          <Grid item md={12} className={`${classes.py4} ${classes.textcenter}`}>
            {/* apply racstrap here */}
            {receiptStatus?.map((obj, index) => {
              return (
                <Typography className={`${classes.colmd12} ${classes.mb2}`}>
                  {t("Payment Receipt")} - {receiptStatus[index].receiptID} :
                  {(txtChange && receiptStatus?.length == 0) || (txtChange && receiptStatus[index]?.documentURL == '') ? (
                    <CircularProgress className={classes.receiptLoader} />
                  ) : receiptStatus != undefined && !receiptStatus[index]?.isLoading && !receiptStatus[index]?.isPaymentFailed ? (
                    <a
                      onClick={() => {
                        setviewReceiptPopup(true)
                        setChoosenReceiptIndex(index)
                      }}
                      style={{
                        textDecoration: 'underline',
                        color: '#2179FE',
                        cursor: 'pointer',
                      }}
                      data-testid='viewReceipt'
                      className={`${classes.me3} ${classes.ms2} ${classes.popUpTxtStyle} ${classes.ms1}`}
                    >
                      {t("View")}
                    </a>
                  ) : (
                    t('Generating receipt failed Please contact IT Help Desk')
                  )}
                </Typography>
              );
            })}

            {receiptResultArray?.cooArray?.length > CONSTANTS.ZERO_NUMBER ? (
              <>
                <Typography
                  className={`${classes.modalfooter} ${classes.textcenter} ${classes.w100} ${classes.mt3}`}
                >
                  {t("Please load the Certificate of Ownership into Tray1 with face up and the top of the form facing front.")}
                </Typography>
                {cofReceipt()}
              </>
            ) : null}
            {receiptResultArray?.extentionArray?.length > CONSTANTS.ZERO_NUMBER ? extensionReceipt() : null}
          </Grid>
        </Grid>
      </>
    );
  }
  const Receiptpopup = () => {

    const receiptStatus = receiptResultArray?.totalFileList?.filter((x) => x?.documentType == 'PRCT' || x.documentType == '');

    return (
      <Grid
        item
        id='delivery-receipt'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex={-1}
        aria-labelledby='autopayconsent'
        aria-hidden='true'
        data-testid='receiptIdPopup'
      >
        <Grid item md={12} className={`${classes.py4} ${classes.textcenter}`}>
          {/* apply racstrap here */}
          {receiptStatus?.map((obj, index) => {
            return (
              <Typography className={`${classes.colmd12} ${classes.mb2}`}>
                {t("Payment Receipt")}- {receiptStatus[index].receiptID} :
                {(txtChange && receiptStatus?.length == 0) || (txtChange && receiptStatus[index]?.documentURL == '') ? (
                  <CircularProgress className={classes.receiptLoader} />
                ) : receiptStatus != undefined && !receiptStatus[index]?.isLoading && !receiptStatus[index]?.isPaymentFailed ? (
                  <a
                    onClick={() => {
                      setviewReceiptPopup(true)
                      setChoosenReceiptIndex(index)
                    }}
                    style={{
                      textDecoration: 'underline',
                      color: '#2179FE',
                      cursor: 'pointer',
                    }}
                    data-testid='viewReceipt'
                    className={`${classes.me3} ${classes.ms2} ${classes.popUpTxtStyle} ${classes.ms1}`}
                  >
                    {t("View")}
                  </a>
                ) : (
                  t('Generating receipt failed Please contact IT Help Desk')
                )}
              </Typography>
            );
          })}

          {receiptResultArray?.cooArray?.length > CONSTANTS.ZERO_NUMBER ? (
            <>
              <Typography
                className={`${classes.modalfooter} ${classes.textcenter} ${classes.w100} ${classes.mt3}`}
              >
                {t("Please load the Certificate of Ownership into Tray1 with face up and the top of the form facing front.")}
              </Typography>
              {cofReceipt()}
            </>
          ) : null}
          {receiptResultArray?.extentionArray?.length > CONSTANTS.ZERO_NUMBER ? extensionReceipt() : null}
          <Grid className={`${classes.w100} ${classes.textcenter}`}>
            <RACButton
              className={classes.mx1}
              color='primary'
              variant='outlined'
              onClick={() => {
                if (featureFlags.RACExchange == CONSTANTS.ONE_STRING && Number(exchangeAgreementId) != 0 && Number(agreementId) != 0) {
                  postAgreementActivity({
                    agreementActivities: [{
                      agreementId: agreementId,
                      activityDescription: `Agreement Exchange Started`,
                      agreementActivityType: "AGMXNGSRT",
                    }]
                  });
                  const enrolledAgreement = exchangedAgreementArray.filter((x: ExchangeAgreementArray) => x.childrenAgreementId == agreementId && x.isAutoPayEnrolled)
                  if (enrolledAgreement?.length > 0 && Number(agreementId) != 0) {

                    setAutoPayConfirmationPopup(true);
                  }
                  else {
                    setRacExchangeAutoPayPopup(true);
                  }
                }
                else {
                  ReceiptOk();
                }
              }}
              data-testid='Receipt_okId'
              style={{ marginTop: '20px' }}
            >
              {t("OK")}
            </RACButton>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const transactionResultHeader = () => (
    <>
      <RACTableCell style={{ textAlign: 'center' }}>{t("Store Number")} </RACTableCell>
      <RACTableCell style={{ textAlign: 'center' }}>
        {t("Transaction Status")}
      </RACTableCell>
    </>
  );
  const transactionResultBody = () => (
    <>
      {transactionResultArray?.map((obj: PaymentAPIResult, index: number) => {
        return (
          <RACTableRow key={index} backgroundColor='white'>
            <RACTableCell key={index} style={{ textAlign: 'center' }}>
              {obj.storeNumber}
            </RACTableCell>
            <RACTableCell key={index} style={{ textAlign: 'center' }}>
              {obj.transactionStatus == 'Passed' ? (
                <TransactionSuccessIcon className={classes.receiptLoader} />
              ) : (
                <FailIcon />
              )}
            </RACTableCell>
          </RACTableRow>
        );
      })}
    </>
  );
  const buildPaymentStatus = () => {
    return (
      <Grid item md={12} data-testid='multi-store'>
        <Grid item md={12} className={classes.textCenter}>
          <RACTable
            className={`${classes.racGrid} ${classes.mb32}`}
            renderTableHead={transactionResultHeader}
            renderTableContent={transactionResultBody}
          />
        </Grid>
        <Grid
          container
          className={`${classes.justifyContentCenter} ${classes.mt4}`}
        >
          <RACButton
            size='small'
            variant='contained'
            color='primary'
            data-testid='payment_status_ok'
            onClick={() => {
              setShowPaymentStatus(false);
              setShowReceiptStatus(true);
            }}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const spinnerpopup = () => {
    return (
      <Grid
        item
        data-testid='spinpart'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex={-1}
        aria-labelledby='transaction'
        aria-hidden='true'
      >
        <Grid item md={12} className={classes.textcenter}>
          <ClipLoader color='blue' loading={load} size={40} />
          {!isPaymentHistory ? <Typography className='row justify-content-center popup-text'>
            {t("Transaction In Progress")}
          </Typography> :
            <Typography className='row justify-content-center popup-text'>
              {t("In Progress")}
            </Typography>
          }
        </Grid>
        <Grid item md={12} className={classes.textcenter}>
          <Typography variant='h6' className={classes.mt3}>
            {t("Please Wait...")}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const print = () => {
    eventFrame.current?.contentWindow?.print();
  };
  const okClickUnavailable = () => {
    setIsAmountMismatch(false);
    setTransactionFail(false);
    // setepayFail(false);
    window.location.reload();
  };
  const renderAmountMismatch = () => {
    return (
      <div>
        <Grid className={classes.textcenter} data-testid='amount_matchId'>
          <AlertIcon className={classes.racErrorIcon}></AlertIcon>
          <Typography className={classes.racErrorFunction}>
            {t("There was an error processing your request. Please use ‘Report an Issue’ quick link under help, or Self Service portal to report this issue, and someone from the support team will promptly assist you with this request.")}           </Typography>
        </Grid>
        <Grid className={classes.textcenter}>
          <RACButton
            autoFocus
            variant='contained'
            color='primary'
            className={classes.me2}
            onClick={okClickUnavailable}
            data-testid='amount_MisMatch_ok'
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  /**The isExceptionProvided() method is used to check whether free time or EPO discount is 
  provided for any agreement
   */
  const isExceptionProvided = () => {
    let selectedEPOAgreements: AgreementDetails[] = agreementDetails.filter(
      (x) =>
        (x.selected &&
          x.storeNumber ==
          storeNumber &&
          x.otherIncomeType == CONSTANTS.EMPTY_STRING &&
          x.acceptEpoFlag == CONSTANTS.ONE_NUMBER &&
          x.isAcceptEPODiscounts?.epoDiscount &&
          x.isAcceptEPODiscounts?.epoDiscount != CONSTANTS.ZREO_TWO_DECIMAL_STRING) ||
        (x.isAcceptEPODiscounts?.pastDueDiscount &&
          x.isAcceptEPODiscounts?.pastDueDiscount != CONSTANTS.ZREO_TWO_DECIMAL_STRING) ||
        (x.isAcceptEPODiscounts?.noteDiscount &&
          x.isAcceptEPODiscounts?.noteDiscount != CONSTANTS.ZREO_TWO_DECIMAL_STRING)
    );
    let selectedFreeTimeAgreements: AgreementDetails[] = agreementDetails.filter(
      (x) =>
        x.selected && x.freeTime && x.freeTime.freeTimeType != CONSTANTS.PROMO_FT
    );
    let storeExceptionPayloadArr: ExceptionTypeArray[] = [];
    if (
      selectedEPOAgreements.length > CONSTANTS.ZERO_NUMBER ||
      selectedFreeTimeAgreements.length > CONSTANTS.ZERO_NUMBER
    ) {
      if (selectedEPOAgreements.length > CONSTANTS.ZERO_NUMBER) {
        storeExceptionPayloadArr.push({ type: CONSTANTS.EPD, isOpen: true });
      }
      if (selectedFreeTimeAgreements.length > CONSTANTS.ZERO_NUMBER) {
        storeExceptionPayloadArr.push({ type: CONSTANTS.REX, isOpen: true });
      }
    }
    setExceptionTypeArr(storeExceptionPayloadArr);
  };
  //facturaModalOne
  const facturaModalOne = () => {
    return (<>
      <Grid>
        <Typography style={{ textAlign: 'center', fontFamily: 'OpenSans-bold' }}> {t("Do you want to generate a invoice")} </Typography>
      </Grid>
      <Grid style={{ marginTop: '15px' }}>
        <Typography style={{ textAlign: 'center', color: 'grey' }}> {t('To generate an invoice, you need to provide the')}  </Typography>
        <Typography style={{ textAlign: 'center', color: 'grey' }}> {t('Facturacon details.')}  </Typography>
      </Grid>
      <Grid
        item
        className={`${classes.raccollg12} ${classes.py4} ${classes.textcenter}`}
        style={{ marginTop: '10px' }}
      >
        <RACButton
          className={classes.mx1}
          color="primary"
          variant="outlined"
          data-bs-dismiss="modal"
          onClick={() => { setOpenFacturaModalOne(false); isPaymentHistory ? null : acceptPaymentOnclick(true); }}
        >
          {t('No')}
        </RACButton>

        <RACButton
          className={`${classes.mx1} ${classes.minHt48px}`}
          color="primary"
          variant="contained"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
          onClick={() => {
            setOpenFacturaModalTwo(true);
            setPopupData(true);
            if (facturaDetails?.[0]?.rfc) {
              setOpenFacturaModalOne(false);
              isPaymentHistory ? handleGenerateInvoice() : acceptPaymentOnclick(true);
              return;
            };
          }}
        >
          {t('Yes')}
        </RACButton>
      </Grid>
    </>)
  }



  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    let isValid = true;

    if (name === 'rfc') {
      const rfcRegex = /^[A-Z]{0,4}\d{0,6}[A-Z0-9]{0,3}$/;
      isValid = rfcRegex.test(value);
    } else if (name === 'zipCode') {
      const zipCodeRegex = /^[0-9]*$/;
      isValid = zipCodeRegex.test(value);
      console.log("hello here", isValid);
    } else if (name === 'email') {
      const emailRegex = /^[a-zA-Z0-9._%+-@]*$/;
      isValid = emailRegex.test(value);
      console.log("in here", isValid)
    }

    if (isValid) {
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      console.error(`Invalid input for ${name}: ${value}`);
    }
  };



  const handleToggleChange = () => {
    setFormData(prevState => ({
      ...prevState,
      generateInvoiceAllPayments: !prevState.generateInvoiceAllPayments,
    }));
  };

  const handleSave = async () => {
    const payload = {
      customerId: customerInfo?.customerId,
      globalCustomerId: customerInfo?.customerDetails?.[0]?.globalCustomerId,
      factura: [
        {
          rfc: formData.rfc,
          name: formData.name,
          zipCode: formData.zipCode,
          taxRegime: formData.taxRegime,
          email: formData.email,
          useOfCfdi: formData.useOfCFDI,
          invoiceReq: formData.generateInvoiceAllPayments ? 'Y' : 'N',
        },
      ],
    };

    try {
      setOpenFacturaModalOne(false)
      setOpenFacturaModalTwo(false);
      const response = await UpdateNoDeReason(payload);
      console.log(response, "getResponseUpdate");
      const updateCustomer = response.UpdateCustomer.value;
      let allKeysHaveValues = true;
      for (const key in updateCustomer) {
        if (updateCustomer.hasOwnProperty(key)) {
          if (updateCustomer[key] === null || updateCustomer[key] === undefined) {
            allKeysHaveValues = false;
            break;
          }
        }
      }
      if (allKeysHaveValues) {
        setSecondPopupData(true);
        isPaymentHistory ? handleGenerateInvoice() : acceptPaymentOnclick(true);
      }
    } catch (err) {
      console.log(err);
      setErrorPoup(true);
    }
  };
  const ErrorMsgPopup = () => {
    console.log('inside the error msg popup');
    return (
      <Grid item md={12}>
        <Grid item md={12} className={classes.textCenter}>
          <AlertIcon></AlertIcon>
          <Typography variant={"body2"} className={classes.RACPOPMsg}>
            {t("Something went wrong.")}
          </Typography>
        </Grid>
        <Grid
          container
          className={`${classes.justifycontentcenter} ${classes.spacerMT4}`}
          style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}
        >
          <RACButton
            variant="contained"
            color="primary"
            isRounded={false}
            onClick={() => setErrorPoup(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  function generateInvoiceModal() {
    return (<>
      <Grid item md={12} className={classes.textCenter}>
        <Typography>
          {t("Factura processed and sent by email, thanks.")}
        </Typography>
        <Grid
          container
          className={`${classes.justifycontentcenter} ${classes.spacerMT4}`}
          style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}
        >
          <RACButton
            variant="contained"
            color="primary"
            isRounded={false}
            onClick={() => setInvoicePopup(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </Grid>
    </>)
  }
  const facturaModalTwo = () => {
    return (
      <>
        <Grid style={{ display: 'flex', minWidth: '400px' }}>
          <Grid style={{ marginLeft: '25px', minWidth: '250px', marginTop: '5px' }}>
            <Grid style={{ marginTop: '10px' }}>
              <RACTextbox
                type="text"
                inputlabel={t('RFC')}
                maxlength={40}
                name="rfc"
                value={formData.rfc}
                OnChange={handleInputChange}
                required={true}
              />
            </Grid>

            <Grid style={{ marginTop: '10px' }}>
              <RACTextbox
                type="text"
                inputlabel={t('Zip Code')}
                maxlength={40}
                name="zipCode"
                value={formData.zipCode}
                OnChange={handleInputChange}
                required={true}
              />
            </Grid>

            <Grid style={{ marginTop: '10px' }}>
              <RACTextbox
                type="text"
                inputlabel={t('Email')}
                maxlength={100}
                name="email"
                value={formData.email}
                OnChange={handleInputChange}
                required={true}
              />
            </Grid>
          </Grid>

          <Grid style={{ marginLeft: '25px', minWidth: '250px', marginTop: '5px' }}>
            <Grid style={{ marginTop: '10px' }}>
              <RACTextbox
                type="text"
                inputlabel={t('Name')}
                maxlength={40}
                name="name"
                value={formData.name}
                disabled={true}
                OnChange={handleInputChange}
                required={true}
              />
            </Grid>


            <Grid style={{ marginTop: '10px' }}>
              <RACSelect
                id="taxRegime"
                name="taxRegime"
                value={formData.taxRegime}
                required={true}
                defaultValue={t("Select")}
                options={taxRegimeOptions.map(option => ({
                  value: option.value,
                  label: option.description
                }))}
                inputLabel={t('Tax Regime')}
                onChange={(e) => setFormData(prevState => ({ ...prevState, taxRegime: e.target.value }))}
              />
            </Grid>

            <Grid style={{ marginTop: '10px' }}>
              <RACSelect
                id="useOfCFDI"
                inputLabel={t('Use of CFDI')}
                value={formData.useOfCFDI}
                required={true}
                defaultValue={t("Select")}
                options={useOfCfdiOptions.map(option => ({
                  value: option.value,
                  label: option.description
                }))}
                name="useOfCFDI"
                onChange={(e) => setFormData(prevState => ({ ...prevState, useOfCFDI: e.target.value }))}
              />
            </Grid>

          </Grid>
        </Grid>

        <Grid className={classes.toggleWrapper} style={{ display: 'flex', alignItems: 'center', marginLeft: '25px', marginTop: '15px' }}>
          <RACToggle
            checked={formData.generateInvoiceAllPayments}
            OnChange={handleToggleChange}
            toggleColor={"#2279fd"}
          />
          <span className={classes.toggleLabel} style={{ marginLeft: '8px', fontSize: '14px', color: '#333' }}>
            {t('Generate Invoice for all Payment')}
          </span>
        </Grid>

        <Grid
          item
          className={`${classes.raccollg12} `}
          style={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-end' }}
        >
          <RACButton
            className={classes.mx1}
            color="primary"
            variant="outlined"
            data-bs-dismiss="modal"
            onClick={handleCancel}
          >
            {t("Cancel")}
          </RACButton>

          <RACButton
            className={`${classes.mx1} ${classes.minHt48px}`}
            color="primary"
            variant="contained"
            data-bs-dismiss="modal"
            onClick={handleSave}
            disabled={!isSaveEnabled} // Disable button if not all fields are filled
          >
            {t("Save")}
          </RACButton>
        </Grid>
      </>
    );

  }

  /** The calculatePayment() method is triggered once the two factor authentication is completed*/
  const calculatePayment = () => {
    if (exceptionTypeArr.length > CONSTANTS.ZERO_NUMBER) {
      storeExceptionInvoke();
    }
    else {
      setload(true)
      invokePaymentAPI();
    }
  }

  /** The storeExceptionCompletedFn() is invoked when the continue button is clicked on the store exception popup 
  this method is invoked */
  const storeExceptionCompletedFn = (response) => {
    let arrayException: ExceptionTypeArray[] = [];
    if (response.some((x) => x.exceptionTypeRefCode == CONSTANTS.EPD)) {
      arrayException = exceptionTypeArr.filter((x) => { x.type != CONSTANTS.EPD })
      // setExceptionTypeArr(exceptionTypeArr)
    }
    if (response.some((x) => x.exceptionTypeRefCode == CONSTANTS.REX)) {
      arrayException = exceptionTypeArr.filter((x) => { x.type != CONSTANTS.REX })
    }
    exceptionTypeArr = arrayException
    setExceptionTypeArr(exceptionTypeArr);
    storeExceptionRequest = response;
    setStoreExceptionRequest(storeExceptionRequest);
    calculatePayment();
  }
  /** The storeExceptionPayloadFormation() method is invoked to form the payload to make the store exception 
    API call 
  */
  const storeExceptionPayloadFormation = (storeExceptionPayloadFormation: TakePaymentRequest, resultOfDoct) => {
    const payload: StoreExceptionPayload[] = [];
    const epoException: StoreExceptionPayload[] = storeExceptionRequest.filter((x) => x?.exceptionTypeRefCode == CONSTANTS.EPD);
    const freeDaysExtension: StoreExceptionPayload[] = storeExceptionRequest.filter((x) => x?.exceptionTypeRefCode == CONSTANTS.REX);
    if (epoException?.length > CONSTANTS.ZERO_NUMBER) {
      epoException.map((obj) => {
        obj.identifierId = Number(resultOfDoct?.receiptId)
      })
    }
    const exceededFreeTime = storeExceptionPayloadFormation?.paymentInfo?.[0]?.exceededFTAmount;
    storeExceptionPayloadFormation?.paymentInfo?.[0]?.agreementPayment?.map((obj: AgreementPaymentEntity) => {
      if (obj?.freeTime != undefined && obj.freeTime?.type != CONSTANTS.PROMO_FT)
        payload.push({
          identifierId: Number(resultOfDoct[0]?.receiptID),
          identifierType: CONSTANTS.RECEIPT.toUpperCase(),
          storeNumber: freeDaysExtension[0]?.storeNumber,
          exceptionTypeRefCode: exceededFreeTime && exceededFreeTime > 0 ? 'CFT' : CONSTANTS.REX,
          exceptionText: freeDaysExtension[0]?.exceptionText,
          customerId: Number(customerId),
          agreementId: Number(obj.agreementId),
          approverId: exceededFreeTime && exceededFreeTime > 0 ? coWorkerDetails.employeeId : undefined
        })
    })
    return { storeException: [...payload, ...epoException] }

  }

  /**
   * This function is used to handle the modal name EPP Customer
   * @returns 
   * 
   */

  const setFacturaDetailsPopup = () => {
    console.log("insideFacturaDetails", facturaDetails?.[0])
    if (facturaDetails?.[0] == undefined) {
      setOpenFacturaModalOne(true);
    }
    else if (facturaDetails?.[0]?.invoiceReq?.toString() == "0" || !facturaDetails?.[0]?.invoiceReq?.toString()) {
      setOpenFacturaModalOne(true);
    }
    else if (facturaDetails?.[0]?.invoiceReq?.toString() === "1") {
      acceptPaymentOnclick(true)
    }
  }
  const getModuleName = () => {
    return (customerInfo?.isEppCustomer == CONSTANTS.STATUS_YES ?
      CONSTANTS.SLA_MODULE_NAME_RAC_COWORKER : CONSTANTS.SLA_MODULE_NAME_ACCEPT_PAYMENT);
  }

  const storeExceptionInvoke = () => {
    if (exceptionTypeArr.some((x) => x.isOpen)) {
      setStoreExceptionEnable(true);
    }
    else {
      setStoreExceptionEnable(false);
    }
  }
  const close = () => {
    settran(false);
    setrecpt(false);
  };

  const renderReceiptPopup = ({
    isOtherStore,
    receiptIndex,
    urlArray,
    isExtension,
    isCOwnerShip,
  }) => {


    const handleClose = () => {
      if (isExtension) {
        setviewExtPopup(false);
      } else {
        setviewReceiptPopup(false);
        setviewCOFPopup(false);
      }
    };
    return (
      <Grid
        item
        data-testid='spinpart'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex={-1}
        aria-labelledby='transaction'
        aria-hidden='true'
        className={classes.paymentmodal}
      >
        <Grid
          item
          md={12}
          className={`${classes.textcenter} ${classes.paymentmodal}`}
          data-testid='receiptIframe'
        >
          <iframe
            ref={eventFrame}
            frameBorder={0}
            width='100%'
            height='750px'
            src={`${urlArray[receiptIndex]?.documentURL}#toolbar=0`}
          ></iframe>
        </Grid>
        <Grid item md={12} className={classes.textend}>
          <RACButton
            variant='outlined'
            color='secondary'
            data-testid='receipt_close'
            className={classes.me2}
            onClick={handleClose}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton variant='contained' color='primary' onClick={print}>
            {t("Print")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const receiptResultHeader = () => (
    <>
      <RACTableCell style={{ textAlign: 'center' }}>{t("Store Number")}</RACTableCell>
      <RACTableCell style={{ textAlign: 'center' }}>{t("Receipt Type")} </RACTableCell>
      <RACTableCell style={{ textAlign: 'center' }}>
        {t("Receipt Status")}
      </RACTableCell>
    </>
  );

  const receiptResultBody = () => (
    <>
      {receiptResultArray?.totalFileList.map((obj: ReceiptStatus, index: number) => {
        return (
          <RACTableRow key={index} backgroundColor='white'>
            <RACTableCell key={index} style={{ textAlign: 'center' }}>
              {obj.storeNumber}
            </RACTableCell>
            <RACTableCell key={index} style={{ textAlign: 'center' }}>
              {obj.documentType == CONSTANTS.RECEIPT_TYPE_PRCT
                ? CONSTANTS.PAYMENT_RECEIPT
                : obj.documentType == CONSTANTS.RECEIPT_TYPE_COOS
                  ? CONSTANTS.CERTIFICATE_OF_OWNERSHIP
                  : obj.documentType == CONSTANTS.RECEIPT_TYPE_EXTRF
                    ? CONSTANTS.EXTENTION_RECEIPT
                    : CONSTANTS.HYPHEN}
            </RACTableCell>
            {obj.isLoading ? (
              <RACTableCell key={index} style={{ textAlign: 'center' }}>
                <CircularProgress className={classes.receiptLoader} />
              </RACTableCell>
            ) : obj.isPaymentFailed ? (
              <RACTableCell key={index} style={{ textAlign: 'center' }}>
                <FailIcon />
              </RACTableCell>
            ) : obj.documentURL !== CONSTANTS.EMPTY_STRING ? (
              <RACTableCell key={index} style={{ textAlign: 'center' }}>
                <a
                  onClick={() => {
                    setviewReceiptPopup(true);
                    setChoosenReceiptIndex(index);
                    // choosenReceiptIndex = index;
                  }}
                  data-testid='viewReceiptId'
                  style={{
                    textDecoration: 'underline',
                    color: '#2179FE',
                    cursor: 'pointer',
                  }}
                  className={`${classes.me3} ${classes.ms2} ${classes.popUpTxtStyle} ${classes.ms1}`}
                >
                  {t("View")}
                </a>
              </RACTableCell>
            ) : (
              <RACTableCell key={index} style={{ textAlign: 'center' }}>
                <a
                  onClick={() => {
                    setreceiptResultArray({ ...receiptResultArray, totalFileList: initialReceiptStatus ?? [] });
                    setShowReceiptStatus(true);
                    invokeReceiptParallel(finalPaymentResult);
                  }}
                  style={{
                    textDecoration: 'underline',
                    color: '#2179FE',
                    cursor: 'pointer',
                  }}
                  className={`${classes.me3} ${classes.ms2} ${classes.popUpTxtStyle} ${classes.ms1}`}
                >
                  {t("Retry")}
                </a>
              </RACTableCell>
            )}
          </RACTableRow>
        );
      })}
    </>
  );

  const buildReceiptStatus = () => {
    return (
      <Grid item md={12}>
        <Grid item md={12} className={classes.textCenter} data-testid='showReceiptStatusId'>
          <RACTable
            className={`${classes.racGrid} ${classes.mb32}`}
            renderTableHead={receiptResultHeader}
            renderTableContent={receiptResultBody}
          />
        </Grid>
        <Grid
          container
          className={`${classes.justifyContentCenter} ${classes.mt4}`}
        >
          <RACButton
            size='small'
            variant='contained'
            color='primary'
            data-testid='showReceiptStatus_ok'
            onClick={() => {
              setShowReceiptStatus(false);
              ReceiptOk();
            }}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const openDeliveryConfirmPopup = () => {//RAC2

    return (
      <Grid className={`${classes2.textCenter}`}>
        <Typography className={`${classesTwo.spacerMT3} ${classesTwo.customerRacpopup4}`}>
          {t("Please confirm the delivery before taking a final payment")}
        </Typography>
        <Grid className={`${classesTwo.buttonsPadding} ${classesTwo.centerButton}`}>
          <RACButton
            variant="outlined"
            color="primary"
            className={`${classesTwo.customerFloatleft} ${classesTwo.mr15px}`}
            onClick={() => {
              setIsDeliveryPopupOpen(false);
            }}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            color="primary"
            variant="contained"
            className={`${classesTwo.customerFloatright}`}
            onClick={() => {
              const nonConfirmedDeliveryId: string = deliveryNonConfirmedAgreements.find((ele: any) => ele.storeNumber == storeNumber)?.agreementId;
              if (nonConfirmedDeliveryId) {
                history.push(`/agreement/rental/delivery/${customerId}/${nonConfirmedDeliveryId}`);
                setIsDeliveryPopupOpen(false);
              } else {
                setIsDeliveryPopupOpen(false);
              }
            }}
            loading={proceedButtonLoader}
          >
            {t("Confirm Delivery")}
          </RACButton>
        </Grid>
      </Grid>
    )
  }
  const CircularProgressInline = ({ days }) => {
    const size = 100; //size of whole circle
    const barWidth = 8; //size of the circular bar width
    const radius = (size - barWidth) / 2; //to limit the progress bar within circle
    const circumference = radius * 2 * Math.PI; //how much needs to be filled based on progress
    const totalDays = 90; // total days as per the business
    const completedIntervals = Math.floor((totalDays - days) / 15); // provides number of intervals
    const completedDays = completedIntervals * 15; // provides the completed days from days to pif
    // Stepper to fill only for 15 days
    const progress = (completedDays / totalDays) * 100; // Shows the days completed in the progress bar
    const strokeDashoffset = circumference - (progress / 100) * circumference; //shows the remaining days in the progress bar

    return (
      <Grid
        style={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: `${size}px`,
          height: `${size}px`
        }}
      >
        <svg
          width={size}
          height={size}
          style={{ transform: "rotate(-90deg)" }}
        >
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#BFDBFE"
            strokeWidth={barWidth}
            fill="none"
          />
          {/* Progress circle (stepped segment fill) */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#3B82F6"
            strokeWidth={barWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{
              transition: "stroke-dashoffset 0.3s ease-in-out"
            }}
          />
        </svg>
        <Grid
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <span
            style={{
              fontSize: "1rem",
              fontWeight: "bold",
              color: "#ef4444"
            }}
          >
            {days}
          </span>
          <span
            style={{
              fontSize: "1rem",
              color: "#ef4444",
              fontWeight: "bold",
            }}
          >
            {t('days')}
          </span>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {secondFactorOpen === true ? (
        <SecondFactor
          setTwoFactorCancelClick={() => { setTwoFactorCancelClick(false); setSecondFactorOpen(false); setOpenFacturaModalTwo(false) }}
          setTwoFactorCompleted={() => {
            setSecondFactorOpen(false);
            calculatePayment();
          }}
          moduleName={getModuleName()}
          //   setEmployeeDetails={setEmployeeDetails}
          //   storeAccessResponse={profileAccResp}
          CurrentRole={coWorkerDetails.role}
        />
      ) : null}
      {freeTimeAuthPopup.secondFactor ? (
        <SecondFactor
          setTwoFactorCancelClick={() => {
            setFreeTimeAuthPopup({
              ...freeTimeAuthPopup,
              popup: false,
              secondFactor: false,
            });
            setProceedButtonLoader(false);
          }}
          setTwoFactorCompleted={() => {
            setFreeTimeAuthPopup({
              ...freeTimeAuthPopup,
              popup: false,
              secondFactor: false,
            });
            setProceedButtonLoader(false);
            setSecondFactorOpen(true);
            // calculatePayment()
          }}
          moduleName='CappedFreeTime'
          //   setEmployeeDetails={setEmployeeDetails}
          //   storeAccessResponse={profileAccResp}
          CurrentRole={coWorkerDetails.role}
        />
      ) : null}
      {customerSignaturePopup ? (
        <CustomerSignature
          customerSignUsingField={customerSignUsingField.field}
          customerSignUsingModule='payment'
          identifier={
            customerSignUsingField.field == CONSTANTS.CLUB.toLowerCase()
              ? Number(parseInt(customerId))
              : Number(pifAgreementID)
          }
          customersArr={getCustDetail(customerInfo)}
          manualSignOptions={CONSTANTS.ManualSignOptions}
          documentTypeArr={[customerSignUsingField.documentType]}
          customerSignatureCompletedFn={() => redirectionFunc(false)}
          customerSignatureCanceledFn={() => redirectionFunc(false)}
          documentGenerateCompleted={clubSignFlow}
        />
      ) : null}
      {barcodeAgreements?.length === 0 &&
        <RACModalCard
          isOpen={recpt}
          maxWidth='xs'
          onClose={() => close()}
          closeIcon={false}>
          {Receiptpopup()}
        </RACModalCard>}
      {barcodeAgreements?.length > 0 &&
        <RACModalCard
          isOpen={recpt}
          maxWidth='md'
          onClose={() => close()}
          closeIcon={false}
          className={`${classes.modalPayment}`}>
          <Grid style={{ display: 'flex', justifyContent: 'center' }}>
            <Grid style={{ backgroundColor: '#F6F6F6', borderRadius: '0px', marginBottom: '10px', minWidth: '700px' }}>{MxReceiptpopup()}</Grid>
          </Grid>
          <Grid style={{ backgroundColor: '#F6F6F6', margin: '0px 30px', borderRadius: '0px' }}><BarcodeGeneration barcodeAgreements={barcodeAgreements} /> </Grid>
          <Grid container justifyContent="flex-end" style={{ marginTop: 24 }}>
            <RACButton
              variant="outlined"
              color="secondary"
              onClick={() => {
                if (featureFlags.RACExchange == CONSTANTS.ONE_STRING && Number(exchangeAgreementId) != 0 && Number(agreementId) != 0) {
                  postAgreementActivity({
                    agreementActivities: [{
                      agreementId: agreementId,
                      activityDescription: `Agreement Exchange Started`,
                      agreementActivityType: "AGMXNGSRT",
                    }]
                  });
                  const enrolledAgreement = exchangedAgreementArray.filter((x: ExchangeAgreementArray) => x.childrenAgreementId == agreementId && x.isAutoPayEnrolled)
                  if (enrolledAgreement?.length > 0 && Number(agreementId) != 0) {

                    setAutoPayConfirmationPopup(true);
                  }
                  else {
                    setRacExchangeAutoPayPopup(true);
                  }
                }
                else {
                  ReceiptOk();
                }
              }}
              style={{ marginRight: 12 }}
            >
              {t("Cancel")}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              onClick={() => {
                if (featureFlags.RACExchange == CONSTANTS.ONE_STRING && Number(exchangeAgreementId) != 0 && Number(agreementId) != 0) {
                  postAgreementActivity({
                    agreementActivities: [{
                      agreementId: agreementId,
                      activityDescription: `Agreement Exchange Started`,
                      agreementActivityType: "AGMXNGSRT",
                    }]
                  });
                  const enrolledAgreement = exchangedAgreementArray.filter((x: ExchangeAgreementArray) => x.childrenAgreementId == agreementId && x.isAutoPayEnrolled)
                  if (enrolledAgreement?.length > 0 && Number(agreementId) != 0) {

                    setAutoPayConfirmationPopup(true);
                  }
                  else {
                    setRacExchangeAutoPayPopup(true);
                  }
                }
                else {
                  ReceiptOk();
                }
              }}
            >
              {t("Proceed")}
            </RACButton>
          </Grid>
        </RACModalCard>

      }

      <RACModalCard
        isOpen={isAmountMismatch}
        maxWidth='xs'
        borderRadius={'20px !important'}
      >
        {renderAmountMismatch()}
      </RACModalCard>

      <RACModalCard
        isOpen={transactionFail}
        maxWidth='xs'
      >
        {transantionFailedPopup()}
      </RACModalCard>

      <RACModalCard
        isOpen={tran}
        maxWidth='xs'
        onClose={() => close()}
        closeIcon={false}>
        {transactioncompletedPopup()}
      </RACModalCard>

      <RACModalCard
        isOpen={showReceiptStatus}
        maxWidth='sm'
        title={t(CONSTANTS.RECEIPT_STATUS)}
        borderRadius={CONSTANTS.BORDER_RADIUS}
      >
        {buildReceiptStatus()}
      </RACModalCard>

      <RACModalCard
        isOpen={viewReceiptPopup}
        className={classes.customModal}
        maxWidth='lg'
        title={t(CONSTANTS.RECEIPT_UPPER_CASE)}
        closeIcon={true}
        onClose={() => setviewReceiptPopup(false)}>
        {renderReceiptPopup({
          isOtherStore: multiStoreSelected,
          receiptIndex: choosenReceiptIndex,
          urlArray: receiptResultArray?.totalFileList ?? [],
          isExtension: false,
          isCOwnerShip: false,
        })}

      </RACModalCard>
      <RACModalCard
        isOpen={showPaymentStatus}
        maxWidth='sm'
        title={t('Transaction Status')}
        borderRadius={CONSTANTS.BORDER_RADIUS}
      >
        {buildPaymentStatus()}
      </RACModalCard>


      <RACModalCard
        isOpen={load}
        maxWidth='xs'
        closeIcon={false}
      >
        {spinnerpopup()}
      </RACModalCard>

      <RACModalCard
        isOpen={showPifPopup}
        maxWidth="sm"
        closeIcon={true}
        onClose={() => {
          setShowPifPopup(false);
          setPifPopupHandled(true);
        }
        }
      >

        <Grid
          style={{
            textAlign: "center",
            marginBottom: "24px",

          }}
        >
          <h2 style={{ fontSize: "2rem", fontWeight: "bold", color: "#1F2937", marginTop: '-15px' }}>
            {t('Almost Purchased in Full!')}
          </h2>
        </Grid>

        <Grid
          style={{
            display: "flex",
            alignItems: "center",
            gap: "24px",
            marginBottom: "32px",
            paddingLeft: "8px",
            paddingRight: "8px"
          }}
        >
          <CircularProgressInline days={daysToPif} />
          <Grid style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
            {PopupContentType == 'finalPayment' ? (
              <>
                <p style={{ fontSize: "1.125rem", color: "#374151", marginBottom: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {customerInfo.customerDetails?.[0]?.firstName || ''} {customerInfo.customerDetails?.[0]?.lastName || ''}
                  </span>
                  {' '}
                  {t('is on their')}
                  {' '}
                  <span style={{ fontWeight: 'bold' }}>{t('final payment')}</span>
                  {' '}
                  {t('of their agreement and will reach ownership soon.')}
                </p>
                <p style={{ fontSize: "1.125rem", color: "#374151", lineHeight: "1.5", marginTop: "8px" }}>
                  {t('Right now is a great opportunity to check in! They might be ready for an upgrade or new product.')}
                </p>
              </>
            ) : (<>
              <p style={{ fontSize: "1.125rem", color: "#374151", marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold" }}>{customerInfo.customerDetails?.[0]?.firstName || ''} {customerInfo.customerDetails?.[0].lastName || ''}</span>
                {' '}
                {t('is only')}
                {' '}
                <span style={{ fontWeight: 'bold' }}>{daysToPif} {t('days')}</span>
                {' '}
                {t('away from ownership.')}
              </p>
              <p style={{ fontSize: "1.125rem", color: "#374151", lineHeight: "1.5", marginTop: "8px", justifyContent: 'center' }}>
                {t('Right now is a great opportunity to check in! They might be ready for an upgrade or new product.')}
              </p>
            </>
            )}
          </Grid>
        </Grid>


        <Grid style={{
          display: "flex",
          gap: "16px",
          justifyContent: 'center',
          marginTop: "8px",
          marginBottom: "40px"
        }}>
          <RACButton
            variant="outlined"
            color="primary"
            onClick={() => {
              setShowPifPopup(false);
              setPifPopupHandled(true);
            }
            }
            style={{ minWidth: "160px" }}
          >
            {t('Remind Me Later')}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            onClick={() => {
              setShowPifPopup(false);
              setPifPopupHandled(true);
              history.push(`/agreement/rental/itemsearch/${customerId}`)
            }}
            style={{ minWidth: "180px" }}
          >
            {t('Create New Agreement')}
          </RACButton>
        </Grid>
      </RACModalCard>


      <RACButton
        color='primary'
        variant='contained'
        data-testid='accept_Payment_id'
        className={classes.ms2}
        style={{ height: '42.5px' }}
        disabled={Object.values(paymentDisable).some((x) => x ? true : false) || !agreementDetails.some((x) => x.selected)}
        onClick={() => featureFlags.EnableFactura != "1" ? acceptPaymentOnclick(true) : setFacturaDetailsPopup()}
      >
        {t("Accept Payment")}
        {/* customer3 */}
      </RACButton>

      <RACModalCard
        isOpen={openSuspenseWithdraw}
        maxWidth='sm'
        borderRadius={CONSTANTS.BORDER_RADIUS}
      // children={buildSuspenseWithdraw()}
      >
        {buildSuspenseWithdraw()}
      </RACModalCard>


      {freeTimeAuthPopup.popup ? (
        <RACModalCard
          isOpen={freeTimeAuthPopup.popup}
          closeIcon={false}
          borderRadius={CONSTANTS.BORDER_RADIUS}
          // onClose={() => setFreeTimeAuthPopup({ ...freeTimeAuthPopup, popup: false })}
          maxWidth={'xs'}
        // children={freeTimeAuthPopupContent()}
        >
          {freeTimeAuthPopupContent()}
        </RACModalCard>

      ) : null}

      {receiptResultArray != undefined && receiptResultArray?.extentionArray?.length > CONSTANTS.ZERO_NUMBER ? (
        <>
          <RACModalCard
            isOpen={viewExtPopup}
            className={classes.customModal}
            maxWidth='lg'
            title={t('Extension Receipt')}
            closeIcon={true}
            onClose={() => setviewExtPopup(false)}>
            {renderReceiptPopup({
              isOtherStore: false,
              receiptIndex: extIndex,
              urlArray: receiptResultArray?.extentionArray ?? [],
              isExtension: true,
              isCOwnerShip: false,
            })}
          </RACModalCard>
        </>
      ) : null}
      <RACModalCard
        isOpen={openCommitmentConfirmation}
        maxWidth='sm'
        borderRadius={CONSTANTS.BORDER_RADIUS}
      >
        {commitmentConfirmation()}
      </RACModalCard>

      {StoreExceptionEnable ? (<StoreException
        isopen={StoreExceptionEnable}
        setStoreExceptionEnable={setStoreExceptionEnable}
        refCode={exceptionTypeArr[0].type}
        identifierType={'RECEIPT'}
        exceptionDescscription={exceptionTypeArr[0].type == CONSTANTS.REX ? CONSTANTS.RENTAL_EXTENTION : null}
        storeExceptionCancelled={() => {
          setStoreExceptionEnable(false);
          setStoreExceptionRequest([])
        }}
        storeExceptionCompleted={(res) => { storeExceptionCompletedFn(res) }}
      />) : null}
      {receiptResultArray != undefined && receiptResultArray?.cooArray?.length > 0 ? (
        <>
          <RACModalCard
            isOpen={viewCOFPopup}
            className={classes.customModal}
            maxWidth='lg'
            title={t('Certificate of Ownership')}
            closeIcon={true}
            onClose={() => setviewCOFPopup(false)}>
            {renderReceiptPopup({
              isOtherStore: false,
              receiptIndex: cofIndex,
              urlArray: receiptResultArray?.cooArray ?? [],
              isExtension: false,
              isCOwnerShip: true,
            })}
          </RACModalCard>
        </>
      ) : null}

      <RACModalCard
        isOpen={sessionExpiredPopupFlag}
        maxWidth='xs'
        borderRadius={CONSTANTS.BORDER_RADIUS}
      >
        {sessionExpiredReloadPopup()}
      </RACModalCard>
      {autoPayConfirmationPopup ? (
        <RACModalCard
          isOpen={autoPayConfirmationPopup}
          closeIcon={false}
          borderRadius={"25px !important"}
          onClose={() => {
            setAutoPayConfirmationPopup(false);
            history.push(`/agreement/rental/delivery/${customerId}/${agreementId}?exagreementid=${exchangeAgreementId}`)
          }}
          maxWidth={"sm"}
        // children={openAutoPayPopup()}
        >
          {openAutoPayPopup()}
        </RACModalCard>
      ) : null}

      {
        racExchangeAutoPayPopup && (
          <RACModalCard
            isOpen={racExchangeAutoPayPopup}
            maxWidth="sm"
            onClose={() => {
              setRacExchangeAutoPayPopup(false),
                history.push(`/agreement/rental/delivery/${customerId}/${agreementId}?exagreementid=${exchangeAgreementId}`)
            }}
            closeIcon={true}
          >
            <Autopay
              cardPopup={racExchangeAutoPayPopup}
              setCardPopup={(res) => setRacExchangeAutoPayPopup(res)}
              unEnrollAutopay={false}
              manageCard={false}
              racExchange={true}
            ></Autopay>
          </RACModalCard>
        )
      }

      {
        isDeliveryPopupOpen && (
          <RACModalCard
            isOpen={isDeliveryPopupOpen}
            maxWidth="xs"
            onClose={() => {
              setIsDeliveryPopupOpen(false)
            }}
            closeIcon={true}
          >
            {openDeliveryConfirmPopup()}
          </RACModalCard>
        )
      }
      {openFacturaModalOne && !(facturaDetails?.[0]?.invoiceReq?.toString() === "1") && (
        <RACModalCard
          isOpen={openFacturaModalOne}
          maxWidth="xs"
          onClose={() => {
            setOpenFacturaModalOne(false)
            if (facturaDetails?.[0]?.invoiceReq.toString() === "0") {
              setOpenFacturaModalTwo(false);
            }
          }}
          closeIcon={true}
          borderRadius={'20px'}
        >
          {facturaModalOne()}
        </RACModalCard>
      )
      }
      {
        openFacturaModalTwo && (
          <RACModalCard
            isOpen={openFacturaModalOne}
            minWidth="400px"
            onClose={() => {
              setOpenFacturaModalTwo(false)
            }}
            closeIcon={true}
            borderRadius={'20px'}
            title={t('Factura Details')}
          >
            {facturaModalTwo()}
          </RACModalCard>
        )
      }
      {
        invoiceError ?
          <RACModalCard
            isOpen={invoiceError}
            maxWidth="xs"
            closeIcon={false}
            borderRadius="20px"
            onClose={() => setInvoiceError(false)}
          >
            {InvoiceErrorMsgPopup()}
          </RACModalCard>
          : null
      }

      {
        errorPopup ?
          <RACModalCard
            isOpen={errorPopup}
            maxWidth="xs"
            closeIcon={false}
            borderRadius="20px"
            onClose={() => setErrorPoup(false)}
          >
            {ErrorMsgPopup()}
          </RACModalCard>
          : null
      }

      {invoicePopup ? <RACModalCard
        isOpen={invoicePopup}
        maxWidth="xs"
        borderRadius="20px"
        onClose={() => setInvoicePopup(false)}
      >
        {generateInvoiceModal()}
      </RACModalCard> :
        null}
    </>
  );
}